import type { JSX } from 'react';

const existingIcons: { [key: string]: JSX.Element } = {
  accordian_closed: (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 11L6.5 6L1.5 1"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  more_btn: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99935 8.66634C8.36754 8.66634 8.66602 8.36786 8.66602 7.99967C8.66602 7.63148 8.36754 7.33301 7.99935 7.33301C7.63116 7.33301 7.33268 7.63148 7.33268 7.99967C7.33268 8.36786 7.63116 8.66634 7.99935 8.66634Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.666 8.66634C13.0342 8.66634 13.3327 8.36786 13.3327 7.99967C13.3327 7.63148 13.0342 7.33301 12.666 7.33301C12.2978 7.33301 11.9993 7.63148 11.9993 7.99967C11.9993 8.36786 12.2978 8.66634 12.666 8.66634Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33268 8.66634C3.70087 8.66634 3.99935 8.36786 3.99935 7.99967C3.99935 7.63148 3.70087 7.33301 3.33268 7.33301C2.96449 7.33301 2.66602 7.63148 2.66602 7.99967C2.66602 8.36786 2.96449 8.66634 3.33268 8.66634Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  back_button_arrow: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 12L6 8L10 4"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  backward_arrow: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.25 9H3.75M3.75 9L9 14.25M3.75 9L9 3.75"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  box_edit: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.16663 3.33332H5.66663C4.26649 3.33332 3.56643 3.33332 3.03165 3.6058C2.56124 3.84549 2.17879 4.22794 1.93911 4.69834C1.66663 5.23312 1.66663 5.93319 1.66663 7.33332V14.3333C1.66663 15.7335 1.66663 16.4335 1.93911 16.9683C2.17879 17.4387 2.56124 17.8212 3.03165 18.0608C3.56643 18.3333 4.26649 18.3333 5.66663 18.3333H12.6666C14.0668 18.3333 14.7668 18.3333 15.3016 18.0608C15.772 17.8212 16.1545 17.4387 16.3941 16.9683C16.6666 16.4335 16.6666 15.7335 16.6666 14.3333V10.8333M6.6666 13.3333H8.06206C8.46971 13.3333 8.67353 13.3333 8.86535 13.2873C9.03541 13.2464 9.19798 13.1791 9.3471 13.0877C9.5153 12.9847 9.65942 12.8405 9.94767 12.5523L17.9166 4.58332C18.607 3.89296 18.607 2.77368 17.9166 2.08332C17.2263 1.39296 16.107 1.39296 15.4166 2.08332L7.44765 10.0523C7.1594 10.3405 7.01527 10.4847 6.9122 10.6528C6.82082 10.802 6.75348 10.9645 6.71265 11.1346C6.6666 11.3264 6.6666 11.5302 6.6666 11.9379V13.3333Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  box_add: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 6.66667V13.3333M6.66667 10H13.3333M6.5 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chat_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66639 7.91667H9.99973M6.66639 10.8333H12.4997M10.4164 16.6667C14.3284 16.6667 17.4997 13.4953 17.4997 9.58333C17.4997 5.67132 14.3284 2.5 10.4164 2.5C6.50438 2.5 3.33306 5.67132 3.33306 9.58333C3.33306 10.375 3.46293 11.1363 3.70254 11.8472C3.7927 12.1147 3.83779 12.2484 3.84592 12.3512C3.85395 12.4527 3.84788 12.5238 3.82277 12.6225C3.79735 12.7223 3.74122 12.8262 3.62897 13.034L2.26593 15.557C2.0715 15.9168 1.97429 16.0968 1.99604 16.2356C2.01499 16.3566 2.08618 16.4631 2.19071 16.5269C2.31071 16.6001 2.51414 16.579 2.92101 16.537L7.18853 16.0958C7.31777 16.0825 7.38238 16.0758 7.44128 16.0781C7.49921 16.0803 7.5401 16.0857 7.59659 16.0987C7.65402 16.112 7.72625 16.1398 7.87069 16.1954C8.66073 16.4998 9.51908 16.6667 10.4164 16.6667Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  reload_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0442 10.7442C16.8127 12.9191 15.5804 14.9572 13.5412 16.1345C10.1533 18.0905 5.8212 16.9298 3.86519 13.5419L3.65686 13.181M2.95515 9.25584C3.18665 7.08092 4.41898 5.04282 6.45813 3.86551C9.84604 1.90951 14.1781 3.07029 16.1341 6.45819L16.3425 6.81904M2.91101 15.055L3.52105 12.7783L5.79776 13.3884M14.202 6.61167L16.4787 7.22172L17.0888 4.94501"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tick_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3333 4L5.99996 11.3333L2.66663 8"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tick_green: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3333 4L5.99996 11.3333L2.66663 8"
        stroke="#28B97B"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendr_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 8.33335H2.5M13.3333 1.66669V5.00002M6.66667 1.66669V5.00002M6.5 18.3334H13.5C14.9001 18.3334 15.6002 18.3334 16.135 18.0609C16.6054 17.8212 16.9878 17.4387 17.2275 16.9683C17.5 16.4336 17.5 15.7335 17.5 14.3334V7.33335C17.5 5.93322 17.5 5.23316 17.2275 4.69838C16.9878 4.22797 16.6054 3.84552 16.135 3.60584C15.6002 3.33335 14.9001 3.33335 13.5 3.33335H6.5C5.09987 3.33335 4.3998 3.33335 3.86502 3.60584C3.39462 3.84552 3.01217 4.22797 2.77248 4.69838C2.5 5.23316 2.5 5.93322 2.5 7.33335V14.3334C2.5 15.7335 2.5 16.4336 2.77248 16.9683C3.01217 17.4387 3.39462 17.8212 3.86502 18.0609C4.3998 18.3334 5.09987 18.3334 6.5 18.3334Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  reload_icon_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.33331 6.66667C1.33331 6.66667 2.66997 4.84548 3.75587 3.75883C4.84177 2.67218 6.34238 2 7.99998 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 7.99998 14C5.26458 14 2.95672 12.1695 2.23449 9.66667M1.33331 6.66667V2.66667M1.33331 6.66667H5.33331"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendr_icon_red: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 8.625V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5H9.375M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M13.5 15.75V11.25M11.25 13.5H15.75"
        stroke="#EA1C1C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pencil_blue: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 15.75H9.74999M1.87497 16.125L6.03692 14.5242C6.30313 14.4219 6.43623 14.3707 6.56076 14.3038C6.67137 14.2444 6.77682 14.1759 6.876 14.099C6.98766 14.0123 7.0885 13.9115 7.29018 13.7098L15.75 5.25C16.5784 4.42157 16.5784 3.07843 15.75 2.25C14.9216 1.42157 13.5784 1.42157 12.75 2.25L4.29018 10.7098C4.0885 10.9115 3.98766 11.0123 3.90101 11.124C3.82405 11.2231 3.75552 11.3286 3.69615 11.4392C3.6293 11.5637 3.57811 11.6968 3.47572 11.9631L1.87497 16.125ZM1.87497 16.125L3.41856 12.1117C3.52902 11.8245 3.58425 11.6809 3.67897 11.6152C3.76176 11.5577 3.8642 11.5359 3.96319 11.5548C4.07647 11.5765 4.18526 11.6853 4.40283 11.9028L6.09715 13.5972C6.31472 13.8147 6.42351 13.9235 6.44514 14.0368C6.46405 14.1358 6.44231 14.2382 6.38483 14.321C6.31905 14.4157 6.17546 14.471 5.88827 14.5814L1.87497 16.125Z"
        stroke="#1369E9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sparkles_white: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.49999 14.6666V11.3333M3.49999 4.66665V1.33331M1.83333 2.99998H5.16666M1.83333 13H5.16666M9.16666 1.99998L8.01054 5.00589C7.82254 5.49471 7.72853 5.73912 7.58235 5.9447C7.45279 6.12691 7.29359 6.28611 7.11139 6.41567C6.9058 6.56185 6.66139 6.65585 6.17257 6.84386L3.16666 7.99998L6.17257 9.1561C6.66139 9.34411 6.9058 9.43811 7.11139 9.58429C7.29359 9.71385 7.45279 9.87305 7.58235 10.0553C7.72853 10.2608 7.82254 10.5053 8.01054 10.9941L9.16666 14L10.3228 10.9941C10.5108 10.5053 10.6048 10.2608 10.751 10.0553C10.8805 9.87305 11.0397 9.71385 11.2219 9.58429C11.4275 9.43811 11.6719 9.34411 12.1608 9.1561L15.1667 7.99998L12.1608 6.84386C11.6719 6.65585 11.4275 6.56185 11.2219 6.41567C11.0397 6.28611 10.8805 6.12691 10.751 5.9447C10.6048 5.73912 10.5108 5.49471 10.3228 5.00589L9.16666 1.99998Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  close_icon_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4L4 12M4 4L12 12" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  close_icon_gray: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4L4 12M4 4L12 12"
        stroke="#D0D5DD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  delete_icon_red: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1667 3.99998V3.46665C11.1667 2.71991 11.1667 2.34654 11.0213 2.06133C10.8935 1.81044 10.6895 1.60647 10.4387 1.47864C10.1534 1.33331 9.78007 1.33331 9.03333 1.33331H7.96667C7.21993 1.33331 6.84656 1.33331 6.56135 1.47864C6.31046 1.60647 6.10649 1.81044 5.97866 2.06133C5.83333 2.34654 5.83333 2.71991 5.83333 3.46665V3.99998M2.5 3.99998H14.5M13.1667 3.99998V11.4666C13.1667 12.5868 13.1667 13.1468 12.9487 13.5746C12.7569 13.951 12.451 14.2569 12.0746 14.4487C11.6468 14.6666 11.0868 14.6666 9.96667 14.6666H7.03333C5.91323 14.6666 5.35318 14.6666 4.92535 14.4487C4.54903 14.2569 4.24307 13.951 4.05132 13.5746C3.83333 13.1468 3.83333 12.5868 3.83333 11.4666V3.99998"
        stroke="#EA1C1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pencil_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66664 14.3333L5.36615 12.9104C5.60278 12.8194 5.72109 12.7739 5.83179 12.7145C5.93011 12.6617 6.02384 12.6008 6.112 12.5324C6.21125 12.4554 6.30089 12.3657 6.48016 12.1865L14 4.66665C14.7364 3.93027 14.7364 2.73636 14 1.99998C13.2636 1.2636 12.0697 1.2636 11.3333 1.99998L3.8135 9.51979C3.63422 9.69906 3.54459 9.7887 3.46757 9.88795C3.39916 9.97611 3.33824 10.0698 3.28546 10.1682C3.22605 10.2789 3.18054 10.3972 3.08953 10.6338L1.66664 14.3333ZM1.66664 14.3333L3.03872 10.766C3.13691 10.5107 3.186 10.383 3.2702 10.3246C3.34379 10.2735 3.43484 10.2542 3.52284 10.271C3.62353 10.2902 3.72023 10.3869 3.91363 10.5803L5.41969 12.0863C5.61309 12.2797 5.70979 12.3764 5.72902 12.4771C5.74582 12.5651 5.7265 12.6562 5.6754 12.7298C5.61694 12.814 5.4893 12.8631 5.23402 12.9613L1.66664 14.3333Z"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  eye_open: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.61342 8.47543C1.52262 8.33167 1.47723 8.25979 1.45182 8.14892C1.43273 8.06565 1.43273 7.93431 1.45182 7.85104C1.47723 7.74017 1.52262 7.66829 1.61341 7.52453C2.36369 6.33654 4.59693 3.33331 8.00027 3.33331C11.4036 3.33331 13.6369 6.33654 14.3871 7.52453C14.4779 7.66829 14.5233 7.74017 14.5487 7.85104C14.5678 7.93431 14.5678 8.06565 14.5487 8.14892C14.5233 8.25979 14.4779 8.33167 14.3871 8.47543C13.6369 9.66342 11.4036 12.6666 8.00027 12.6666C4.59693 12.6666 2.36369 9.66342 1.61342 8.47543Z"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00027 9.99998C9.10484 9.99998 10.0003 9.10455 10.0003 7.99998C10.0003 6.89541 9.10484 5.99998 8.00027 5.99998C6.8957 5.99998 6.00027 6.89541 6.00027 7.99998C6.00027 9.10455 6.8957 9.99998 8.00027 9.99998Z"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  loader_icon_blue: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="loader"
    >
      <path
        className="spinner-bg-outer"
        d="M9 1C10.0506 1 11.0909 1.20693 12.0615 1.60896C13.0321 2.011 13.914 2.60028 14.6569 3.34315C15.3997 4.08601 15.989 4.96793 16.391 5.93853C16.7931 6.90914 17 7.94943 17 9C17 10.0506 16.7931 11.0909 16.391 12.0615C15.989 13.0321 15.3997 13.914 14.6569 14.6569C13.914 15.3997 13.0321 15.989 12.0615 16.391C11.0909 16.7931 10.0506 17 9 17C7.94942 17 6.90914 16.7931 5.93853 16.391C4.96793 15.989 4.08601 15.3997 3.34315 14.6569C2.60028 13.914 2.011 13.0321 1.60896 12.0615C1.20693 11.0909 1 10.0506 1 9C1 7.94942 1.20693 6.90914 1.60896 5.93853C2.011 4.96793 2.60028 4.08601 3.34315 3.34314C4.08602 2.60028 4.96793 2.011 5.93853 1.60896C6.90914 1.20693 7.94943 1 9 1L9 1Z"
        stroke="#ACCCFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="spinner-bg-overlay"
        d="M9 1C10.0506 1 11.0909 1.20693 12.0615 1.60896C13.0321 2.011 13.914 2.60028 14.6569 3.34315C15.3997 4.08601 15.989 4.96793 16.391 5.93853C16.7931 6.90914 17 7.94943 17 9"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus_icon_white: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 3.33337V12.6667M3.83333 8.00004H13.1667"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  printer_icon_white: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8860_74)">
        <path
          d="M12 4.66668V3.46668C12 2.71994 12 2.34657 11.8547 2.06136C11.7268 1.81047 11.5229 1.6065 11.272 1.47867C10.9868 1.33334 10.6134 1.33334 9.86666 1.33334H6.13333C5.38659 1.33334 5.01322 1.33334 4.72801 1.47867C4.47712 1.6065 4.27315 1.81047 4.14532 2.06136C4 2.34657 3.99999 2.71994 3.99999 3.46668V4.66668M3.99999 12C3.38001 12 3.07002 12 2.81569 11.9319C2.12551 11.7469 1.58641 11.2078 1.40148 10.5176C1.33333 10.2633 1.33333 9.95332 1.33333 9.33334V7.86668C1.33333 6.74657 1.33333 6.18652 1.55132 5.7587C1.74306 5.38237 2.04902 5.07641 2.42535 4.88466C2.85317 4.66668 3.41322 4.66668 4.53333 4.66668H11.4667C12.5868 4.66668 13.1468 4.66668 13.5746 4.88466C13.951 5.07641 14.2569 5.38237 14.4487 5.7587C14.6667 6.18652 14.6667 6.74657 14.6667 7.86668V9.33334C14.6667 9.95332 14.6667 10.2633 14.5985 10.5176C14.4136 11.2078 13.8745 11.7469 13.1843 11.9319C12.93 12 12.62 12 12 12M10 7.00001H12M6.13333 14.6667H9.86666C10.6134 14.6667 10.9868 14.6667 11.272 14.5214C11.5229 14.3935 11.7268 14.1895 11.8547 13.9387C12 13.6534 12 13.2801 12 12.5333V11.4667C12 10.7199 12 10.3466 11.8547 10.0614C11.7268 9.81047 11.5229 9.6065 11.272 9.47867C10.9868 9.33334 10.6134 9.33334 9.86666 9.33334H6.13333C5.38659 9.33334 5.01322 9.33334 4.72801 9.47867C4.47712 9.6065 4.27315 9.81047 4.14532 10.0614C4 10.3466 3.99999 10.7199 3.99999 11.4667V12.5333C3.99999 13.2801 4 13.6534 4.14532 13.9387C4.27315 14.1895 4.47712 14.3935 4.72801 14.5214C5.01322 14.6667 5.38659 14.6667 6.13333 14.6667Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8860_74">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  row_icon_white: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8667 6.66667C12.6134 6.66667 12.9868 6.66667 13.272 6.52134C13.5229 6.39351 13.7268 6.18954 13.8547 5.93865C14 5.65344 14 5.28007 14 4.53333V4.13333C14 3.3866 14 3.01323 13.8547 2.72801C13.7268 2.47713 13.5229 2.27316 13.272 2.14533C12.9868 2 12.6134 2 11.8667 2L4.13333 2C3.3866 2 3.01323 2 2.72801 2.14532C2.47713 2.27316 2.27316 2.47713 2.14532 2.72801C2 3.01323 2 3.3866 2 4.13333L2 4.53333C2 5.28007 2 5.65344 2.14532 5.93865C2.27316 6.18954 2.47713 6.39351 2.72801 6.52134C3.01323 6.66667 3.3866 6.66667 4.13333 6.66667L11.8667 6.66667Z"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8667 14C12.6134 14 12.9868 14 13.272 13.8547C13.5229 13.7268 13.7268 13.5229 13.8547 13.272C14 12.9868 14 12.6134 14 11.8667V11.4667C14 10.7199 14 10.3466 13.8547 10.0613C13.7268 9.81046 13.5229 9.60649 13.272 9.47866C12.9868 9.33333 12.6134 9.33333 11.8667 9.33333L4.13333 9.33333C3.3866 9.33333 3.01323 9.33333 2.72801 9.47866C2.47713 9.60649 2.27316 9.81046 2.14532 10.0613C2 10.3466 2 10.7199 2 11.4667L2 11.8667C2 12.6134 2 12.9868 2.14532 13.272C2.27316 13.5229 2.47713 13.7268 2.72801 13.8547C3.01323 14 3.3866 14 4.13333 14H11.8667Z"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendar_icon_white: (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.75 7.5H1.25M11 1.5V4.5M5 1.5V4.5M4.85 16.5H11.15C12.4101 16.5 13.0402 16.5 13.5215 16.2548C13.9448 16.039 14.289 15.6948 14.5048 15.2715C14.75 14.7902 14.75 14.1601 14.75 12.9V6.6C14.75 5.33988 14.75 4.70982 14.5048 4.22852C14.289 3.80516 13.9448 3.46095 13.5215 3.24524C13.0402 3 12.4101 3 11.15 3H4.85C3.58988 3 2.95982 3 2.47852 3.24524C2.05516 3.46095 1.71095 3.80516 1.49524 4.22852C1.25 4.70982 1.25 5.33988 1.25 6.6V12.9C1.25 14.1601 1.25 14.7902 1.49524 15.2715C1.71095 15.6948 2.05516 16.039 2.47852 16.2548C2.95982 16.5 3.58988 16.5 4.85 16.5Z"
        stroke="white"
        strokeOpacity="0.7"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendar_icon_blue: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.25 5.83366H1.75M9.33333 1.16699V3.50033M4.66667 1.16699V3.50033M4.55 12.8337H9.45C10.4301 12.8337 10.9201 12.8337 11.2945 12.6429C11.6238 12.4751 11.8915 12.2074 12.0593 11.8781C12.25 11.5038 12.25 11.0138 12.25 10.0337V5.13366C12.25 4.15357 12.25 3.66352 12.0593 3.28918C11.8915 2.95989 11.6238 2.69218 11.2945 2.5244C10.9201 2.33366 10.4301 2.33366 9.45 2.33366H4.55C3.56991 2.33366 3.07986 2.33366 2.70552 2.5244C2.37623 2.69218 2.10852 2.95989 1.94074 3.28918C1.75 3.66352 1.75 4.15357 1.75 5.13366V10.0337C1.75 11.0138 1.75 11.5038 1.94074 11.8781C2.10852 12.2074 2.37623 12.4751 2.70552 12.6429C3.07986 12.8337 3.56991 12.8337 4.55 12.8337Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendar_ticked_icon_blue: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M6.75 12L8.25 13.5L11.625 10.125M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z"
        stroke="#1369E9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendar_plus_icon_blue: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 6H2.25M12 1.5V3.75M6 1.5V3.75M9 13.5V9M6.75 11.25H11.25M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z"
        stroke="#1369E9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  three_dot_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 9.75C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 9.75C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25C13.8358 8.25 13.5 8.58579 13.5 9C13.5 9.41421 13.8358 9.75 14.25 9.75Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 9.75C4.16421 9.75 4.5 9.41421 4.5 9C4.5 8.58579 4.16421 8.25 3.75 8.25C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  settings_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.04634 14.5283L7.48468 15.5142C7.61498 15.8076 7.82763 16.057 8.09685 16.232C8.36606 16.4069 8.68026 16.5001 9.00134 16.5C9.32243 16.5001 9.63663 16.4069 9.90584 16.232C10.1751 16.057 10.3877 15.8076 10.518 15.5142L10.9563 14.5283C11.1124 14.1785 11.3748 13.8869 11.7063 13.695C12.0399 13.5026 12.4258 13.4206 12.8088 13.4608L13.8813 13.575C14.2006 13.6088 14.5228 13.5492 14.8089 13.4035C15.0949 13.2578 15.3326 13.0322 15.493 12.7542C15.6536 12.4763 15.7302 12.1577 15.7133 11.8372C15.6964 11.5166 15.5869 11.2079 15.398 10.9483L14.763 10.0758C14.5369 9.76285 14.4161 9.38611 14.418 9C14.4179 8.61494 14.5399 8.23976 14.7663 7.92833L15.4013 7.05583C15.5902 6.79632 15.6998 6.48755 15.7166 6.16701C15.7335 5.84646 15.657 5.52791 15.4963 5.25C15.3359 4.97193 15.0983 4.74637 14.8122 4.60067C14.5261 4.45497 14.2039 4.3954 13.8847 4.42917L12.8122 4.54333C12.4292 4.58356 12.0433 4.50159 11.7097 4.30917C11.3775 4.11619 11.115 3.82302 10.9597 3.47167L10.518 2.48583C10.3877 2.19238 10.1751 1.94304 9.90584 1.76805C9.63663 1.59306 9.32243 1.49995 9.00134 1.5C8.68026 1.49995 8.36606 1.59306 8.09685 1.76805C7.82763 1.94304 7.61498 2.19238 7.48468 2.48583L7.04634 3.47167C6.89104 3.82302 6.6285 4.11619 6.29634 4.30917C5.96275 4.50159 5.57684 4.58356 5.19384 4.54333L4.11801 4.42917C3.79876 4.3954 3.47656 4.45497 3.1905 4.60067C2.90443 4.74637 2.66677 4.97193 2.50634 5.25C2.34571 5.52791 2.26918 5.84646 2.28604 6.16701C2.30291 6.48755 2.41244 6.79632 2.60134 7.05583L3.23634 7.92833C3.4628 8.23976 3.58475 8.61494 3.58468 9C3.58475 9.38506 3.4628 9.76024 3.23634 10.0717L2.60134 10.9442C2.41244 11.2037 2.30291 11.5124 2.28604 11.833C2.26918 12.1535 2.34571 12.4721 2.50634 12.75C2.66693 13.0279 2.90461 13.2534 3.19064 13.399C3.47667 13.5447 3.79878 13.6044 4.11801 13.5708L5.19051 13.4567C5.57351 13.4164 5.95942 13.4984 6.29301 13.6908C6.62641 13.8833 6.89017 14.1765 7.04634 14.5283Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_close_icon_red: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.75 6.75L11.25 11.25M11.25 6.75L6.75 11.25M5.85 15.75H12.15C13.4101 15.75 14.0402 15.75 14.5215 15.5048C14.9448 15.289 15.289 14.9448 15.5048 14.5215C15.75 14.0402 15.75 13.4101 15.75 12.15V5.85C15.75 4.58988 15.75 3.95982 15.5048 3.47852C15.289 3.05516 14.9448 2.71095 14.5215 2.49524C14.0402 2.25 13.4101 2.25 12.15 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75Z"
        stroke="#EA1C1C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_cut: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8791_286)">
        <path
          d="M3.5 10.3311C4.9945 9.46656 6 7.85071 6 6C6 4.14929 4.9945 2.53343 3.5 1.66891M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8791_286">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  circle_loader_fill_large: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="loader"
    >
      <rect x="4" y="4" width="32" height="32" rx="16" stroke="#F2F4F7" strokeWidth="8" />
      <path
        d="M35.9124 18.3275C36.2655 21.6879 35.5458 25.0738 33.8564 28C32.167 30.9262 29.5945 33.2424 26.5078 34.6167"
        stroke="#1369E9"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="spinner-bg-overlay"
      />
    </svg>
  ),
  circle_loader_fill: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="loader"
    >
      <rect x="3" y="3" width="26" height="26" rx="13" stroke="#F2F4F7" strokeWidth="6" />
      <path
        d="M28.9288 14.6411C29.2157 17.3714 28.631 20.1225 27.2583 22.5C25.8857 24.8775 23.7956 26.7595 21.2876 27.8761"
        stroke="#1369E9"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="spinner-bg-overlay"
      />
    </svg>
  ),
  circle_loader: (
    <svg viewBox="0 0, 100 100" width="40" className="loader">
      <defs>
        <linearGradient
          id="linear"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
          gradientTransform="rotate(10)"
        >
          <stop offset="10%" className="stop-color" />
          <stop offset="100%" stopColor="whitesmoke" />
        </linearGradient>
      </defs>
      <path
        d="M 50 10 A 40 40 0 1 0 90 50"
        stroke="url(#linear)"
        strokeWidth="13"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  ),
  circle_warning_exclamation: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#FFBF00"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tick_white: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3337 4L6.00033 11.3333L2.66699 8"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  warning_triangle_exclamation_red: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z"
        stroke="#EA1C1C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  warning_triangle_exclamation_orange: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99975 7.49999V10.8333M9.99975 14.1667H10.0081M8.84585 3.2431L1.99178 15.0819C1.61161 15.7386 1.42153 16.0669 1.44962 16.3364C1.47412 16.5714 1.59727 16.785 1.7884 16.924C2.00753 17.0833 2.38691 17.0833 3.14568 17.0833H16.8538C17.6126 17.0833 17.992 17.0833 18.2111 16.924C18.4022 16.785 18.5254 16.5714 18.5499 16.3364C18.578 16.0669 18.3879 15.7386 18.0077 15.0819L11.1537 3.24309C10.7748 2.58879 10.5854 2.26164 10.3383 2.15176C10.1228 2.05592 9.87672 2.05592 9.66117 2.15176C9.41406 2.26164 9.22466 2.58879 8.84585 3.2431Z"
        stroke="#FF6200"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copy_icon: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 6V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H3.9C3.05992 1.5 2.63988 1.5 2.31901 1.66349C2.03677 1.8073 1.8073 2.03677 1.66349 2.31901C1.5 2.63988 1.5 3.05992 1.5 3.9V9.6C1.5 10.4401 1.5 10.8601 1.66349 11.181C1.8073 11.4632 2.03677 11.6927 2.31901 11.8365C2.63988 12 3.05992 12 3.9 12H6M8.4 16.5H14.1C14.9401 16.5 15.3601 16.5 15.681 16.3365C15.9632 16.1927 16.1927 15.9632 16.3365 15.681C16.5 15.3601 16.5 14.9401 16.5 14.1V8.4C16.5 7.55992 16.5 7.13988 16.3365 6.81901C16.1927 6.53677 15.9632 6.3073 15.681 6.16349C15.3601 6 14.9401 6 14.1 6H8.4C7.55992 6 7.13988 6 6.81901 6.16349C6.53677 6.3073 6.3073 6.53677 6.16349 6.81901C6 7.13988 6 7.55992 6 8.4V14.1C6 14.9401 6 15.3601 6.16349 15.681C6.3073 15.9632 6.53677 16.1927 6.81901 16.3365C7.13988 16.5 7.55992 16.5 8.4 16.5Z"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  close_icon_red: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4L4 12M4 4L12 12"
        stroke="#EA1C1C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  upload_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33464 13.5352C2.32965 12.8625 1.66797 11.7168 1.66797 10.4167C1.66797 8.46369 3.16089 6.85941 5.06775 6.68281C5.45781 4.31011 7.51817 2.5 10.0013 2.5C12.4844 2.5 14.5448 4.31011 14.9349 6.68281C16.8417 6.85941 18.3346 8.46369 18.3346 10.4167C18.3346 11.7168 17.673 12.8625 16.668 13.5352M6.66797 13.3333L10.0013 10M10.0013 10L13.3346 13.3333M10.0013 10V17.5"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pencil_slash_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.00001 15.0012H15.75M2.25003 15.0011H3.50594C3.87282 15.0011 4.05627 15.0011 4.2289 14.9597C4.38195 14.923 4.52827 14.8624 4.66248 14.7801C4.81385 14.6873 4.94357 14.5576 5.20299 14.2982L14.6251 4.87615C15.2464 4.25483 15.2464 3.24747 14.6251 2.62615C14.0037 2.00483 12.9964 2.00483 12.375 2.62615L2.95298 12.0482C2.69355 12.3076 2.56383 12.4373 2.47107 12.5887C2.38883 12.7229 2.32822 12.8692 2.29148 13.0223C2.25003 13.1949 2.25003 13.3784 2.25003 13.7453V15.0011Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pencil_tilt_icon_black: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 9.00012L9.99994 9.54714C9.73473 9.83718 9.37507 10.0001 9.00006 10.0001C8.62505 10.0001 8.2654 9.83718 8.00019 9.54714C7.73461 9.25768 7.37499 9.09515 7.00009 9.09515C6.62519 9.09515 6.26557 9.25768 5.99999 9.54714M1.5 10.0001H2.33727C2.58186 10.0001 2.70416 10.0001 2.81925 9.97248C2.92128 9.94799 3.01883 9.90758 3.1083 9.85275C3.20921 9.79091 3.29569 9.70444 3.46864 9.53148L9.75001 3.25011C10.1642 2.8359 10.1642 2.16433 9.75001 1.75011C9.3358 1.3359 8.66423 1.3359 8.25001 1.75011L1.96863 8.03148C1.79568 8.20444 1.7092 8.29091 1.64736 8.39183C1.59253 8.4813 1.55213 8.57885 1.52763 8.68088C1.5 8.79597 1.5 8.91826 1.5 9.16286V10.0001Z"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  truck_icon_blue: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12V4.65C12 3.80992 12 3.38988 11.8365 3.06901C11.6927 2.78677 11.4632 2.5573 11.181 2.41349C10.8601 2.25 10.4401 2.25 9.6 2.25H3.9C3.05992 2.25 2.63988 2.25 2.31901 2.41349C2.03677 2.5573 1.8073 2.78677 1.66349 3.06901C1.5 3.38988 1.5 3.80992 1.5 4.65V9.6C1.5 10.4401 1.5 10.8601 1.66349 11.181C1.8073 11.4632 2.03677 11.6927 2.31901 11.8365C2.63988 12 3.05992 12 3.9 12H12ZM12 12H15.3C15.72 12 15.9301 12 16.0905 11.9183C16.2316 11.8463 16.3463 11.7316 16.4183 11.5905C16.5 11.4301 16.5 11.22 16.5 10.8V8.74706C16.5 8.56361 16.5 8.47189 16.4793 8.38558C16.4609 8.30905 16.4306 8.23589 16.3895 8.16879C16.3431 8.0931 16.2782 8.02824 16.1485 7.89853L14.6015 6.35147C14.4718 6.22176 14.4069 6.1569 14.3312 6.11052C14.2641 6.0694 14.191 6.03909 14.1144 6.02072C14.0281 6 13.9364 6 13.7529 6H12M6.75 13.875C6.75 14.9105 5.91053 15.75 4.875 15.75C3.83947 15.75 3 14.9105 3 13.875C3 12.8395 3.83947 12 4.875 12C5.91053 12 6.75 12.8395 6.75 13.875ZM15 13.875C15 14.9105 14.1605 15.75 13.125 15.75C12.0895 15.75 11.25 14.9105 11.25 13.875C11.25 12.8395 12.0895 12 13.125 12C14.1605 12 15 12.8395 15 13.875Z"
        stroke="#1369E9"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  truck_icon_red: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12V4.65C12 3.80992 12 3.38988 11.8365 3.06901C11.6927 2.78677 11.4632 2.5573 11.181 2.41349C10.8601 2.25 10.4401 2.25 9.6 2.25H3.9C3.05992 2.25 2.63988 2.25 2.31901 2.41349C2.03677 2.5573 1.8073 2.78677 1.66349 3.06901C1.5 3.38988 1.5 3.80992 1.5 4.65V9.6C1.5 10.4401 1.5 10.8601 1.66349 11.181C1.8073 11.4632 2.03677 11.6927 2.31901 11.8365C2.63988 12 3.05992 12 3.9 12H12ZM12 12H15.3C15.72 12 15.9301 12 16.0905 11.9183C16.2316 11.8463 16.3463 11.7316 16.4183 11.5905C16.5 11.4301 16.5 11.22 16.5 10.8V8.74706C16.5 8.56361 16.5 8.47189 16.4793 8.38558C16.4609 8.30905 16.4306 8.23589 16.3895 8.16879C16.3431 8.0931 16.2782 8.02824 16.1485 7.89853L14.6015 6.35147C14.4718 6.22176 14.4069 6.1569 14.3312 6.11052C14.2641 6.0694 14.191 6.03909 14.1144 6.02072C14.0281 6 13.9364 6 13.7529 6H12M6.75 13.875C6.75 14.9105 5.91053 15.75 4.875 15.75C3.83947 15.75 3 14.9105 3 13.875C3 12.8395 3.83947 12 4.875 12C5.91053 12 6.75 12.8395 6.75 13.875ZM15 13.875C15 14.9105 14.1605 15.75 13.125 15.75C12.0895 15.75 11.25 14.9105 11.25 13.875C11.25 12.8395 12.0895 12 13.125 12C14.1605 12 15 12.8395 15 13.875Z"
        stroke="#EA1C1C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_up_arrow_to_right_icon_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.75 5.75L14.75 1.25M14.75 1.25H10.25M14.75 1.25L8.75 7.25M6.5 2.75H4.85C3.58988 2.75 2.95982 2.75 2.47852 2.99524C2.05516 3.21095 1.71095 3.55516 1.49524 3.97852C1.25 4.45982 1.25 5.08988 1.25 6.35V11.15C1.25 12.4101 1.25 13.0402 1.49524 13.5215C1.71095 13.9448 2.05516 14.289 2.47852 14.5048C2.95982 14.75 3.58988 14.75 4.85 14.75H9.65C10.9101 14.75 11.5402 14.75 12.0215 14.5048C12.4448 14.289 12.789 13.9448 13.0048 13.5215C13.25 13.0402 13.25 12.4101 13.25 11.15V9.5"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arrow_right_icon_black: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 9H15.5M15.5 9L11 4.5M15.5 9L11 13.5"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arrow_right_without_line_icon_black: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 18L15 12L9 6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  search_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 15.75L12.4875 12.4875M14.25 8.25C14.25 11.5637 11.5637 14.25 8.25 14.25C4.93629 14.25 2.25 11.5637 2.25 8.25C2.25 4.93629 4.93629 2.25 8.25 2.25C11.5637 2.25 14.25 4.93629 14.25 8.25Z"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  bookmark_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 5.85C3.75 4.58988 3.75 3.95982 3.99524 3.47852C4.21095 3.05516 4.55516 2.71095 4.97852 2.49524C5.45982 2.25 6.08988 2.25 7.35 2.25H10.65C11.9101 2.25 12.5402 2.25 13.0215 2.49524C13.4448 2.71095 13.789 3.05516 14.0048 3.47852C14.25 3.95982 14.25 4.58988 14.25 5.85V15.75L9 12.75L3.75 15.75V5.85Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  bell_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2498 14.25C11.2498 15.4926 10.2424 16.5 8.99979 16.5C7.75715 16.5 6.74979 15.4926 6.74979 14.25M10.3472 4.67892C10.6738 4.34148 10.8748 3.88171 10.8748 3.375C10.8748 2.33947 10.0353 1.5 8.99979 1.5C7.96426 1.5 7.12479 2.33947 7.12479 3.375C7.12479 3.88171 7.32579 4.34148 7.65241 4.67892M13.4998 8.4C13.4998 7.36566 13.0257 6.37368 12.1818 5.64228C11.3379 4.91089 10.1933 4.5 8.99979 4.5C7.80632 4.5 6.66172 4.91089 5.81781 5.64228C4.9739 6.37368 4.49979 7.36566 4.49979 8.4C4.49979 10.1114 4.07539 11.3629 3.54584 12.2585C2.94229 13.2792 2.64052 13.7896 2.65244 13.9115C2.66607 14.051 2.69118 14.095 2.8043 14.1777C2.90317 14.25 3.39992 14.25 4.39343 14.25H13.6061C14.5997 14.25 15.0964 14.25 15.1953 14.1777C15.3084 14.095 15.3335 14.051 15.3471 13.9115C15.3591 13.7896 15.0573 13.2792 14.4537 12.2585C13.9242 11.3629 13.4998 10.1114 13.4998 8.4Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  support_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2374_25767)">
        <path
          d="M6.8522 6.85221L3.6967 3.69672M3.6967 14.3033L6.87598 11.124M11.1458 11.1478L14.3013 14.3033M14.3013 3.69672L11.1216 6.87646M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9C6 7.34315 7.34315 6 9 6C10.6569 6 12 7.34315 12 9Z"
          stroke="#667085"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2374_25767">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  vertical_three_dots: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99998 8.66699C8.36817 8.66699 8.66665 8.36851 8.66665 8.00033C8.66665 7.63214 8.36817 7.33366 7.99998 7.33366C7.63179 7.33366 7.33331 7.63214 7.33331 8.00033C7.33331 8.36851 7.63179 8.66699 7.99998 8.66699Z"
        stroke="#D0D5DD"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99998 4.00033C8.36817 4.00033 8.66665 3.70185 8.66665 3.33366C8.66665 2.96547 8.36817 2.66699 7.99998 2.66699C7.63179 2.66699 7.33331 2.96547 7.33331 3.33366C7.33331 3.70185 7.63179 4.00033 7.99998 4.00033Z"
        stroke="#D0D5DD"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99998 13.3337C8.36817 13.3337 8.66665 13.0352 8.66665 12.667C8.66665 12.2988 8.36817 12.0003 7.99998 12.0003C7.63179 12.0003 7.33331 12.2988 7.33331 12.667C7.33331 13.0352 7.63179 13.3337 7.99998 13.3337Z"
        stroke="#D0D5DD"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  hour_glass_icon_white: (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="saving"
    >
      <path
        d="M6.49967 12.3333H10.4997M4.89967 1.33333H12.0997C12.473 1.33333 12.6597 1.33333 12.8023 1.40599C12.9278 1.46991 13.0298 1.57189 13.0937 1.69733C13.1663 1.83994 13.1663 2.02663 13.1663 2.39999V3.78301C13.1663 4.10913 13.1663 4.27219 13.1295 4.42564C13.0968 4.56169 13.043 4.69175 12.9699 4.81104C12.8874 4.9456 12.7721 5.0609 12.5415 5.2915L10.5873 7.24575C10.3232 7.50976 10.1912 7.64176 10.1418 7.79398C10.0983 7.92788 10.0983 8.07211 10.1418 8.20601C10.1912 8.35823 10.3232 8.49023 10.5873 8.75424L12.5415 10.7085C12.7721 10.9391 12.8874 11.0544 12.9699 11.1889C13.043 11.3082 13.0968 11.4383 13.1295 11.5744C13.1663 11.7278 13.1663 11.8909 13.1663 12.217V13.6C13.1663 13.9734 13.1663 14.16 13.0937 14.3027C13.0298 14.4281 12.9278 14.5301 12.8023 14.594C12.6597 14.6667 12.473 14.6667 12.0997 14.6667H4.89967C4.52631 14.6667 4.33962 14.6667 4.19701 14.594C4.07157 14.5301 3.96959 14.4281 3.90567 14.3027C3.83301 14.16 3.83301 13.9734 3.83301 13.6V12.217C3.83301 11.8909 3.83301 11.7278 3.86985 11.5744C3.90251 11.4383 3.95638 11.3082 4.02949 11.1889C4.11194 11.0544 4.22724 10.9391 4.45785 10.7085L6.41209 8.75424C6.67611 8.49023 6.80811 8.35823 6.85757 8.20601C6.90108 8.07211 6.90108 7.92788 6.85757 7.79398C6.80811 7.64177 6.6761 7.50976 6.41209 7.24575L4.45785 5.2915C4.22725 5.0609 4.11194 4.9456 4.02949 4.81104C3.95638 4.69175 3.90251 4.56169 3.86985 4.42564C3.83301 4.27219 3.83301 4.10913 3.83301 3.78301V2.39999C3.83301 2.02663 3.83301 1.83994 3.90567 1.69733C3.96959 1.57189 4.07157 1.46991 4.19701 1.40599C4.33962 1.33333 4.52631 1.33333 4.89967 1.33333Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  delete_icon_white: (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 4.5V3.9C11 3.05992 11 2.63988 10.8365 2.31901C10.6927 2.03677 10.4632 1.8073 10.181 1.66349C9.86012 1.5 9.44008 1.5 8.6 1.5H7.4C6.55992 1.5 6.13988 1.5 5.81901 1.66349C5.53677 1.8073 5.3073 2.03677 5.16349 2.31901C5 2.63988 5 3.05992 5 3.9V4.5M6.5 8.625V12.375M9.5 8.625V12.375M1.25 4.5H14.75M13.25 4.5V12.9C13.25 14.1601 13.25 14.7902 13.0048 15.2715C12.789 15.6948 12.4448 16.039 12.0215 16.2548C11.5402 16.5 10.9101 16.5 9.65 16.5H6.35C5.08988 16.5 4.45982 16.5 3.97852 16.2548C3.55516 16.039 3.21095 15.6948 2.99524 15.2715C2.75 14.7902 2.75 14.1601 2.75 12.9V4.5"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  previous_arrow_icon_black: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25 30L15 20L25 10"
        stroke="black"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  next_arrow_icon_black: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 30L25 20L15 10"
        stroke="black"
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  video_badge_icon: (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6.39844" y="6.40039" width="51.2" height="51.2" fill="#FDE6E6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.1626 5.8241C0 8.10583 0 11.0928 0 17.0667V46.9333C0 52.9072 0 55.8942 1.1626 58.1759C2.18525 60.183 3.81704 61.8148 5.8241 62.8374C8.10583 64 11.0928 64 17.0667 64H46.9333C52.9072 64 55.8942 64 58.1759 62.8374C60.183 61.8148 61.8148 60.183 62.8374 58.1759C64 55.8942 64 52.9072 64 46.9333V17.0667C64 11.0928 64 8.10583 62.8374 5.8241C61.8148 3.81704 60.183 2.18525 58.1759 1.1626C55.8942 0 52.9072 0 46.9333 0H17.0667C11.0928 0 8.10583 0 5.8241 1.1626C3.81704 2.18525 2.18525 3.81704 1.1626 5.8241ZM27.1517 19.0204L42.37 28.8036C42.8804 29.1316 43.3513 29.4343 43.7125 29.716C44.087 30.0081 44.533 30.4168 44.7889 31.0223C45.1253 31.8186 45.1253 32.7171 44.7889 33.5133C44.533 34.1189 44.087 34.5276 43.7125 34.8197C43.3513 35.1013 42.8804 35.404 42.37 35.7321L27.1518 45.5152C26.5592 45.8962 26.0248 46.2398 25.5713 46.4759C25.1156 46.713 24.4936 46.9806 23.772 46.929C22.8462 46.8629 21.9946 46.398 21.4384 45.655C21.0048 45.0759 20.8935 44.408 20.8466 43.8964C20.7999 43.3873 20.8 42.7521 20.8 42.0477V22.4881C20.8 21.7837 20.7999 21.1483 20.8466 20.6393C20.8935 20.1277 21.0048 19.4598 21.4384 18.8807C21.9946 18.1376 22.8462 17.6728 23.772 17.6066C24.4936 17.5551 25.1156 17.8226 25.5713 18.0598C26.0248 18.2958 26.5592 18.6394 27.1517 19.0204Z"
        fill="#EA1C1C"
      />
    </svg>
  ),
  file_upload_laoder_icon_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="loader"
    >
      <path
        d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
        opacity=".10"
      />
      <path
        d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
        className="spinner-bg-overlay"
      />
    </svg>
  ),
  close_icon_white: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 1.5L1.5 10.5M1.5 1.5L10.5 10.5"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  reload_icon_white: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 8.33333C17.5 8.33333 15.8292 6.05685 14.4718 4.69854C13.1144 3.34022 11.2387 2.5 9.16666 2.5C5.02453 2.5 1.66666 5.85786 1.66666 10C1.66666 14.1421 5.02453 17.5 9.16666 17.5C12.5859 17.5 15.4707 15.2119 16.3735 12.0833M17.5 8.33333V3.33333M17.5 8.33333H12.5"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_warning_exclamation_icon_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8248_204)">
        <path
          d="M7.99998 10.6667V8M7.99998 5.33334H8.00665M14.6666 8C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8C1.33331 4.3181 4.31808 1.33334 7.99998 1.33334C11.6819 1.33334 14.6666 4.3181 14.6666 8Z"
          stroke="#667085"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8248_204">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  boxed_warning_exclamation_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 12V9M9 6H9.0075M5.85 15.75H12.15C13.4101 15.75 14.0402 15.75 14.5215 15.5048C14.9448 15.289 15.289 14.9448 15.5048 14.5215C15.75 14.0402 15.75 13.4101 15.75 12.15V5.85C15.75 4.58988 15.75 3.95982 15.5048 3.47852C15.289 3.05516 14.9448 2.71095 14.5215 2.49524C14.0402 2.25 13.4101 2.25 12.15 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75Z"
        stroke="#98A2B3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_warning_exclamation_icon_red: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 8V12M12 16H12.01M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke="#EA1C1C"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_dollar_icon_green: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.66659 9.77782C5.66659 10.6369 6.36303 11.3334 7.22214 11.3334H8.66659C9.58706 11.3334 10.3333 10.5872 10.3333 9.66671C10.3333 8.74623 9.58706 8.00004 8.66659 8.00004H7.33325C6.41278 8.00004 5.66659 7.25385 5.66659 6.33337C5.66659 5.4129 6.41278 4.66671 7.33325 4.66671H8.7777C9.63681 4.66671 10.3333 5.36315 10.3333 6.22226M7.99992 3.66671V4.66671M7.99992 11.3334V12.3334M14.6666 8.00004C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004Z"
        stroke="#28B97B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_three_by_four_piece_icon_yellow: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1402 10.5933C13.7161 11.5963 13.0527 12.4801 12.2081 13.1675C11.3635 13.8549 10.3634 14.325 9.29515 14.5365C8.22692 14.7481 7.12314 14.6948 6.08029 14.3812C5.03743 14.0676 4.08727 13.5034 3.31287 12.7378C2.53846 11.9722 1.9634 11.0285 1.63794 9.98931C1.31249 8.9501 1.24656 7.847 1.44592 6.77643C1.64528 5.70586 2.10385 4.70042 2.78155 3.84803C3.45925 2.99563 4.33544 2.32222 5.33352 1.88667M14.1594 5.44878C14.4263 6.09309 14.59 6.77425 14.6455 7.46723C14.6593 7.63843 14.6661 7.72403 14.6321 7.80114C14.6037 7.86555 14.5475 7.9265 14.4855 7.95996C14.4114 8.00001 14.3188 8.00001 14.1335 8.00001H8.53352C8.34684 8.00001 8.2535 8.00001 8.18219 7.96367C8.11947 7.93172 8.06848 7.88072 8.03652 7.818C8.00019 7.7467 8.00019 7.65336 8.00019 7.46667V1.86667C8.00019 1.68143 8.00019 1.58881 8.04024 1.51466C8.07369 1.45272 8.13464 1.39646 8.19905 1.36807C8.27616 1.33407 8.36176 1.34094 8.53296 1.35466C9.22595 1.41022 9.9071 1.57393 10.5514 1.84081C11.3602 2.17584 12.0952 2.6669 12.7142 3.28596C13.3333 3.90502 13.8244 4.63995 14.1594 5.44878Z"
        stroke="#FFBF00"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  three_horizondal_line_icon: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 9H15.75M2.25 4.5H15.75M2.25 13.5H15.75"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  two_rectangle_merged_icon: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 2.25V15.75M5.85 2.25H12.15C13.4101 2.25 14.0402 2.25 14.5215 2.49524C14.9448 2.71095 15.289 3.05516 15.5048 3.47852C15.75 3.95982 15.75 4.58988 15.75 5.85V12.15C15.75 13.4101 15.75 14.0402 15.5048 14.5215C15.289 14.9448 14.9448 15.289 14.5215 15.5048C14.0402 15.75 13.4101 15.75 12.15 15.75H5.85C4.58988 15.75 3.95982 15.75 3.47852 15.5048C3.05516 15.289 2.71095 14.9448 2.49524 14.5215C2.25 14.0402 2.25 13.4101 2.25 12.15V5.85C2.25 4.58988 2.25 3.95982 2.49524 3.47852C2.71095 3.05516 3.05516 2.71095 3.47852 2.49524C3.95982 2.25 4.58988 2.25 5.85 2.25Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus_icon_grey: (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="5" width="10" height="1.5" rx="0.75" fill="#D9D9D9" />
      <rect
        x="5.75"
        y="0.75"
        width="10"
        height="1.5"
        rx="0.75"
        transform="rotate(90 5.75 0.75)"
        fill="#D9D9D9"
      />
    </svg>
  ),
  view_list_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 9L6.75 9M15.75 4.5L6.75 4.5M15.75 13.5L6.75 13.5M3.75 9C3.75 9.41421 3.41421 9.75 3 9.75C2.58579 9.75 2.25 9.41421 2.25 9C2.25 8.58579 2.58579 8.25 3 8.25C3.41421 8.25 3.75 8.58579 3.75 9ZM3.75 4.5C3.75 4.91421 3.41421 5.25 3 5.25C2.58579 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 2.58579 3.75 3 3.75C3.41421 3.75 3.75 4.08579 3.75 4.5ZM3.75 13.5C3.75 13.9142 3.41421 14.25 3 14.25C2.58579 14.25 2.25 13.9142 2.25 13.5C2.25 13.0858 2.58579 12.75 3 12.75C3.41421 12.75 3.75 13.0858 3.75 13.5Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_tick_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.625 9L7.875 11.25L12.375 6.75M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pin_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.2817 11.7124L2.03906 15.955M8.76997 4.98151L7.5993 6.15218C7.50381 6.24767 7.45606 6.29542 7.40166 6.33336C7.35338 6.36703 7.3013 6.39491 7.2465 6.4164C7.18475 6.44062 7.11854 6.45386 6.98612 6.48035L4.23777 7.03002C3.52354 7.17286 3.16643 7.24429 2.99935 7.43257C2.85381 7.59661 2.78734 7.81613 2.81746 8.03335C2.85202 8.28269 3.10954 8.5402 3.62458 9.05524L8.93888 14.3695C9.45392 14.8846 9.71144 15.1421 9.96078 15.1767C10.178 15.2068 10.3975 15.1403 10.5615 14.9948C10.7498 14.8277 10.8213 14.4706 10.9641 13.7564L11.5138 11.008C11.5403 10.8756 11.5535 10.8094 11.5777 10.7476C11.5992 10.6928 11.6271 10.6407 11.6608 10.5925C11.6987 10.5381 11.7465 10.4903 11.8419 10.3948L13.0126 9.22415C13.0737 9.1631 13.1042 9.13257 13.1377 9.10592C13.1676 9.08224 13.1991 9.06087 13.2322 9.04198C13.2694 9.02073 13.3091 9.00372 13.3884 8.96971L15.2592 8.16795C15.805 7.93405 16.0779 7.8171 16.2018 7.62811C16.3102 7.46284 16.349 7.26147 16.3097 7.06776C16.2648 6.84625 16.0549 6.63632 15.635 6.21645L11.7777 2.3591C11.3578 1.93923 11.1479 1.72929 10.9264 1.68439C10.7327 1.64512 10.5313 1.6839 10.366 1.7923C10.177 1.91626 10.0601 2.18915 9.82617 2.73492L9.02441 4.60569C8.9904 4.68505 8.9734 4.72473 8.95214 4.76194C8.93325 4.795 8.91188 4.82657 8.8882 4.85638C8.86155 4.88993 8.83102 4.92046 8.76997 4.98151Z"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  duplicate_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 11.25C3.05109 11.25 2.70163 11.25 2.42597 11.1358C2.05843 10.9836 1.76642 10.6916 1.61418 10.324C1.5 10.0484 1.5 9.69891 1.5 9V3.9C1.5 3.05992 1.5 2.63988 1.66349 2.31901C1.8073 2.03677 2.03677 1.8073 2.31901 1.66349C2.63988 1.5 3.05992 1.5 3.9 1.5H9C9.69891 1.5 10.0484 1.5 10.324 1.61418C10.6916 1.76642 10.9836 2.05843 11.1358 2.42597C11.25 2.70163 11.25 3.05109 11.25 3.75M9.15 16.5H14.1C14.9401 16.5 15.3601 16.5 15.681 16.3365C15.9632 16.1927 16.1927 15.9632 16.3365 15.681C16.5 15.3601 16.5 14.9401 16.5 14.1V9.15C16.5 8.30992 16.5 7.88988 16.3365 7.56901C16.1927 7.28677 15.9632 7.0573 15.681 6.91349C15.3601 6.75 14.9401 6.75 14.1 6.75H9.15C8.30992 6.75 7.88988 6.75 7.56901 6.91349C7.28677 7.0573 7.0573 7.28677 6.91349 7.56901C6.75 7.88988 6.75 8.30992 6.75 9.15V14.1C6.75 14.9401 6.75 15.3601 6.91349 15.681C7.0573 15.9632 7.28677 16.1927 7.56901 16.3365C7.88988 16.5 8.30992 16.5 9.15 16.5Z"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_pencil_edit_icon_balck: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.25 3.00017H5.1C3.83988 3.00017 3.20982 3.00017 2.72852 3.24541C2.30516 3.46112 1.96095 3.80533 1.74524 4.22869C1.5 4.70999 1.5 5.34005 1.5 6.60017V12.9002C1.5 14.1603 1.5 14.7903 1.74524 15.2716C1.96095 15.695 2.30516 16.0392 2.72852 16.2549C3.20982 16.5002 3.83988 16.5002 5.1 16.5002H11.4C12.6601 16.5002 13.2902 16.5002 13.7715 16.2549C14.1948 16.0392 14.539 15.695 14.7548 15.2716C15 14.7903 15 14.1603 15 12.9002V9.75017M5.99998 12.0002H7.25589C7.62277 12.0002 7.80622 12.0002 7.97885 11.9587C8.1319 11.922 8.27822 11.8614 8.41243 11.7791C8.5638 11.6864 8.69352 11.5567 8.95294 11.2972L16.125 4.12517C16.7463 3.50385 16.7463 2.49649 16.125 1.87517C15.5037 1.25385 14.4963 1.25385 13.875 1.87517L6.70293 9.04723C6.4435 9.30665 6.31378 9.43637 6.22102 9.58774C6.13878 9.72195 6.07817 9.86827 6.04143 10.0213C5.99998 10.194 5.99998 10.3774 5.99998 10.7443V12.0002Z"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_delete_bg_icon_red: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="#FFEEEE" />
      <path
        d="M24 14V13.2C24 12.0799 24 11.5198 23.782 11.092C23.5903 10.7157 23.2843 10.4097 22.908 10.218C22.4802 10 21.9201 10 20.8 10H19.2C18.0799 10 17.5198 10 17.092 10.218C16.7157 10.4097 16.4097 10.7157 16.218 11.092C16 11.5198 16 12.0799 16 13.2V14M18 19.5V24.5M22 19.5V24.5M11 14H29M27 14V25.2C27 26.8802 27 27.7202 26.673 28.362C26.3854 28.9265 25.9265 29.3854 25.362 29.673C24.7202 30 23.8802 30 22.2 30H17.8C16.1198 30 15.2798 30 14.638 29.673C14.0735 29.3854 13.6146 28.9265 13.327 28.362C13 27.7202 13 26.8802 13 25.2V14"
        stroke="#EA1C1C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="#FDE6E6" />
    </svg>
  ),
  boxed_close_bg_icon_red: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" fill="#FFEEEE" />
      <rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="#FDE6E6" />
      <path
        d="M26 14L14 26M14 14L26 26"
        stroke="#EA1C1C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus_icon_balck: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 2.5V9.5M2.5 6H9.5"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  hyphen_icon_black: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 6H9.5" stroke="#101828" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  circle_right_arrow_icon_red: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 6L16.5 9M16.5 9L13.5 12M16.5 9H6.75M11.25 3.15303C10.2939 2.57871 9.18393 2.25 8 2.25C4.41015 2.25 1.5 5.27208 1.5 9C1.5 12.7279 4.41015 15.75 8 15.75C9.18393 15.75 10.2939 15.4213 11.25 14.847"
        stroke="#EA1C1C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  eye_open_icon_black: (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.815092 6.53488C0.712952 6.37315 0.661882 6.29229 0.633293 6.16756C0.611819 6.07387 0.611819 5.92613 0.633293 5.83244C0.661882 5.70771 0.712952 5.62685 0.815092 5.46512C1.65915 4.12863 4.17155 0.75 8.0003 0.75C11.8291 0.75 14.3415 4.12863 15.1855 5.46512C15.2877 5.62685 15.3387 5.70771 15.3673 5.83244C15.3888 5.92613 15.3888 6.07387 15.3673 6.16756C15.3387 6.29229 15.2877 6.37315 15.1855 6.53488C14.3415 7.87137 11.8291 11.25 8.0003 11.25C4.17155 11.25 1.65915 7.87137 0.815092 6.53488Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0003 8.25C9.24294 8.25 10.2503 7.24264 10.2503 6C10.2503 4.75736 9.24294 3.75 8.0003 3.75C6.75766 3.75 5.7503 4.75736 5.7503 6C5.7503 7.24264 6.75766 8.25 8.0003 8.25Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  eye_closed_icon_black: (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.10583 2.39488C7.39482 2.35482 7.69295 2.33333 8 2.33333C11.6301 2.33333 14.0121 5.33656 14.8124 6.52455C14.9092 6.66833 14.9576 6.74023 14.9847 6.85112C15.0051 6.93439 15.0051 7.06578 14.9847 7.14905C14.9576 7.25993 14.9088 7.3323 14.8113 7.47705C14.5981 7.79343 14.273 8.23807 13.8423 8.7203M4.24827 3.47669C2.71086 4.45447 1.66714 5.81292 1.18833 6.52352C1.09104 6.66791 1.0424 6.74011 1.01528 6.85099C0.994914 6.93426 0.994906 7.06563 1.01526 7.14891C1.04237 7.25979 1.09079 7.33168 1.18764 7.47545C1.9879 8.66344 4.36993 11.6667 8 11.6667C9.46369 11.6667 10.7245 11.1784 11.7605 10.5177M1.60027 1L14.3997 13M6.49157 5.58579C6.10553 5.94772 5.86675 6.44772 5.86675 7C5.86675 8.10457 6.82184 9 8 9C8.58908 9 9.12239 8.77614 9.50843 8.41421"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_pause_icon_red: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.125 11.25V6.75M10.875 11.25V6.75M5.85 15.75H12.15C13.4101 15.75 14.0402 15.75 14.5215 15.5048C14.9448 15.289 15.289 14.9448 15.5048 14.5215C15.75 14.0402 15.75 13.4101 15.75 12.15V5.85C15.75 4.58988 15.75 3.95982 15.5048 3.47852C15.289 3.05516 14.9448 2.71095 14.5215 2.49524C14.0402 2.25 13.4101 2.25 12.15 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75Z"
        stroke="#FF6200"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_pause_icon_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.125 10.25V5.75M9.875 10.25V5.75M4.85 14.75H11.15C12.4101 14.75 13.0402 14.75 13.5215 14.5048C13.9448 14.289 14.289 13.9448 14.5048 13.5215C14.75 13.0402 14.75 12.4101 14.75 11.15V4.85C14.75 3.58988 14.75 2.95982 14.5048 2.47852C14.289 2.05516 13.9448 1.71095 13.5215 1.49524C13.0402 1.25 12.4101 1.25 11.15 1.25H4.85C3.58988 1.25 2.95982 1.25 2.47852 1.49524C2.05516 1.71095 1.71095 2.05516 1.49524 2.47852C1.25 2.95982 1.25 3.58988 1.25 4.85V11.15C1.25 12.4101 1.25 13.0402 1.49524 13.5215C1.71095 13.9448 2.05516 14.289 2.47852 14.5048C2.95982 14.75 3.58988 14.75 4.85 14.75Z"
        stroke="#6C737F"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  quality_check_icon_pink: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 8.25H6M7.5 11.25H6M12 5.25H6M15 7.875V5.1C15 3.83988 15 3.20982 14.7548 2.72852C14.539 2.30516 14.1948 1.96095 13.7715 1.74524C13.2902 1.5 12.6601 1.5 11.4 1.5H6.6C5.33988 1.5 4.70982 1.5 4.22852 1.74524C3.80516 1.96095 3.46095 2.30516 3.24524 2.72852C3 3.20982 3 3.83988 3 5.1V12.9C3 14.1601 3 14.7902 3.24524 15.2715C3.46095 15.6948 3.80516 16.039 4.22852 16.2548C4.70982 16.5 5.33988 16.5 6.6 16.5H8.625M16.5 16.5L15.375 15.375M16.125 13.5C16.125 14.9497 14.9497 16.125 13.5 16.125C12.0503 16.125 10.875 14.9497 10.875 13.5C10.875 12.0503 12.0503 10.875 13.5 10.875C14.9497 10.875 16.125 12.0503 16.125 13.5Z"
        stroke="#EE46BC"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  quote_no_task_icon_orange: (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3953 17.0534L12.9991 15.7023L11.6029 17.0534C10.8333 17.7982 9.58023 17.7982 8.81061 17.0534C8.04099 16.3086 8.04099 15.1007 8.81061 14.3511L10.2068 13L8.81061 11.6489C8.04099 10.9041 8.04099 9.6914 8.81061 8.94661C9.58023 8.20182 10.8333 8.20182 11.6029 8.94661L12.9991 10.2977L14.3953 8.94661C15.1649 8.20182 16.4131 8.20182 17.1876 8.94661C17.9572 9.6914 17.9572 10.9041 17.1876 11.6489L15.7914 13L17.1876 14.3511C17.9572 15.0959 17.9572 16.3038 17.1876 17.0534C16.4131 17.7982 15.1649 17.7982 14.3953 17.0534ZM13.3494 14.6901L15.0958 16.3802C15.4806 16.7526 16.1072 16.7526 16.492 16.3802C16.8768 16.0078 16.8768 15.4015 16.492 15.0291L14.7456 13.339C14.5531 13.1528 14.5531 12.852 14.7456 12.6658L16.492 10.9757C16.8768 10.6033 16.8768 9.99696 16.492 9.62456C16.1072 9.25217 15.4806 9.25217 15.0958 9.62456L13.3494 11.3147C13.157 11.5009 12.8462 11.5009 12.6538 11.3147L10.9073 9.62456C10.5225 9.25217 9.89597 9.25217 9.51116 9.62456C9.12635 9.99696 9.12635 10.6033 9.51116 10.9757L11.2576 12.6658C11.45 12.852 11.45 13.1528 11.2576 13.339L9.51116 15.0291C9.12635 15.4015 9.12635 16.0078 9.51116 16.3802C9.89597 16.7526 10.5225 16.7526 10.9073 16.3802L12.6538 14.6901C12.8412 14.5039 13.157 14.4991 13.3494 14.6901Z"
        fill="#FFA064"
      />
      <path
        d="M18.8709 3.16493C19.2796 3.16493 19.6109 2.8443 19.6109 2.44878C19.6109 2.05326 19.2796 1.73264 18.8709 1.73264C18.4622 1.73264 18.1309 2.05326 18.1309 2.44878C18.1309 2.8443 18.4622 3.16493 18.8709 3.16493Z"
        fill="#FFA064"
      />
      <path
        d="M3.57693 4.11978C3.98563 4.11978 4.31695 3.79915 4.31695 3.40364C4.31695 3.00812 3.98563 2.68749 3.57693 2.68749C3.16823 2.68749 2.83691 3.00812 2.83691 3.40364C2.83691 3.79915 3.16823 4.11978 3.57693 4.11978Z"
        fill="#FFA064"
      />
      <path
        d="M3.57693 22.7396C3.98563 22.7396 4.31695 22.419 4.31695 22.0234C4.31695 21.6279 3.98563 21.3073 3.57693 21.3073C3.16823 21.3073 2.83691 21.6279 2.83691 22.0234C2.83691 22.419 3.16823 22.7396 3.57693 22.7396Z"
        fill="#FFA064"
      />
      <path
        d="M22.5705 4.11979C22.843 4.11979 23.0638 3.90603 23.0638 3.64236C23.0638 3.37868 22.843 3.16492 22.5705 3.16492C22.298 3.16492 22.0771 3.37868 22.0771 3.64236C22.0771 3.90603 22.298 4.11979 22.5705 4.11979Z"
        fill="#FFA064"
      />
      <path
        d="M23.5578 20.3524C23.8303 20.3524 24.0511 20.1387 24.0511 19.875C24.0511 19.6113 23.8303 19.3976 23.5578 19.3976C23.2853 19.3976 23.0645 19.6113 23.0645 19.875C23.0645 20.1387 23.2853 20.3524 23.5578 20.3524Z"
        fill="#FFA064"
      />
      <path
        d="M7.77069 3.64235C8.04316 3.64235 8.26403 3.4286 8.26403 3.16492C8.26403 2.90125 8.04316 2.68749 7.77069 2.68749C7.49822 2.68749 7.27734 2.90125 7.27734 3.16492C7.27734 3.4286 7.49822 3.64235 7.77069 3.64235Z"
        fill="#FFA064"
      />
      <path
        d="M20.1037 23.6944C20.3762 23.6944 20.597 23.4807 20.597 23.217C20.597 22.9533 20.3762 22.7396 20.1037 22.7396C19.8312 22.7396 19.6104 22.9533 19.6104 23.217C19.6104 23.4807 19.8312 23.6944 20.1037 23.6944Z"
        fill="#FFA064"
      />
      <path
        d="M8.26385 24.1719C8.53632 24.1719 8.7572 23.9581 8.7572 23.6944C8.7572 23.4308 8.53632 23.217 8.26385 23.217C7.99139 23.217 7.77051 23.4308 7.77051 23.6944C7.77051 23.9581 7.99139 24.1719 8.26385 24.1719Z"
        fill="#FFA064"
      />
      <path
        d="M12.7522 23.6992L3.55136 18.5573C3.39842 18.4713 3.30469 18.3138 3.30469 18.1419V7.85807C3.30469 7.68619 3.39842 7.52864 3.55136 7.4427L12.7522 2.30077C12.9052 2.21484 13.0927 2.21484 13.2456 2.30077L22.4465 7.4427C22.5994 7.52864 22.6931 7.68619 22.6931 7.85807V18.1419C22.6931 18.3138 22.5994 18.4713 22.4465 18.5573L13.2456 23.6992C13.0927 23.7852 12.9052 23.7852 12.7522 23.6992ZM4.29138 17.865L12.9989 22.7348L21.7065 17.8698V8.13498L12.9989 3.26518L4.29138 8.13498V17.865Z"
        fill="#FFA064"
      />
    </svg>
  ),
  boxed_left_arrow_icon_blue: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 6L6 9M6 9L9 12M6 9H12M5.85 15.75H12.15C13.4101 15.75 14.0402 15.75 14.5215 15.5048C14.9448 15.289 15.289 14.9448 15.5048 14.5215C15.75 14.0402 15.75 13.4101 15.75 12.15V5.85C15.75 4.58988 15.75 3.95982 15.5048 3.47852C15.289 3.05516 14.9448 2.71095 14.5215 2.49524C14.0402 2.25 13.4101 2.25 12.15 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75Z"
        stroke="#1369E9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rescheduled_icon_blue: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 6.75H12.375C14.239 6.75 15.75 8.26104 15.75 10.125C15.75 11.989 14.239 13.5 12.375 13.5H9M2.25 6.75L5.25 3.75M2.25 6.75L5.25 9.75"
        stroke="#1369E9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_close_icon_green: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.625 9L7.875 11.25L12.375 6.75M5.85 15.75H12.15C13.4101 15.75 14.0402 15.75 14.5215 15.5048C14.9448 15.289 15.289 14.9448 15.5048 14.5215C15.75 14.0402 15.75 13.4101 15.75 12.15V5.85C15.75 4.58988 15.75 3.95982 15.5048 3.47852C15.289 3.05516 14.9448 2.71095 14.5215 2.49524C14.0402 2.25 13.4101 2.25 12.15 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75Z"
        stroke="#28B97B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  boxed_play_icon_blue: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.125 5.724C6.125 5.36604 6.125 5.18705 6.19981 5.08713C6.265 5.00006 6.36478 4.94558 6.47328 4.93783C6.59779 4.92893 6.74834 5.02572 7.04945 5.21929L10.5899 7.49529C10.8512 7.66326 10.9818 7.74725 11.027 7.85404C11.0664 7.94735 11.0664 8.05265 11.027 8.14596C10.9818 8.25275 10.8512 8.33674 10.5899 8.50471L7.04946 10.7807C6.74834 10.9743 6.59779 11.0711 6.47328 11.0622C6.36478 11.0544 6.265 10.9999 6.19981 10.9129C6.125 10.8129 6.125 10.634 6.125 10.276V5.724Z"
        stroke="#1369E9"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25 4.85C1.25 3.58988 1.25 2.95982 1.49524 2.47852C1.71095 2.05516 2.05516 1.71095 2.47852 1.49524C2.95982 1.25 3.58988 1.25 4.85 1.25H11.15C12.4101 1.25 13.0402 1.25 13.5215 1.49524C13.9448 1.71095 14.289 2.05516 14.5048 2.47852C14.75 2.95982 14.75 3.58988 14.75 4.85V11.15C14.75 12.4101 14.75 13.0402 14.5048 13.5215C14.289 13.9448 13.9448 14.289 13.5215 14.5048C13.0402 14.75 12.4101 14.75 11.15 14.75H4.85C3.58988 14.75 2.95982 14.75 2.47852 14.5048C2.05516 14.289 1.71095 13.9448 1.49524 13.5215C1.25 13.0402 1.25 12.4101 1.25 11.15V4.85Z"
        stroke="#1369E9"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dollar_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 13.3334C5 15.1744 6.49238 16.6667 8.33333 16.6667H11.6667C13.5076 16.6667 15 15.1744 15 13.3334C15 11.4925 13.5076 10.0001 11.6667 10.0001H8.33333C6.49238 10.0001 5 8.5077 5 6.66675C5 4.8258 6.49238 3.33341 8.33333 3.33341H11.6667C13.5076 3.33341 15 4.8258 15 6.66675M10 1.66675V18.3334"
        stroke="#1369E9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  organization_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.24996 9.16667H3.83329C3.36658 9.16667 3.13323 9.16667 2.95497 9.25749C2.79817 9.33739 2.67068 9.46487 2.59079 9.62167C2.49996 9.79993 2.49996 10.0333 2.49996 10.5V17.5M13.75 9.16667H16.1666C16.6333 9.16667 16.8667 9.16667 17.045 9.25749C17.2018 9.33739 17.3292 9.46487 17.4091 9.62167C17.5 9.79993 17.5 10.0333 17.5 10.5V17.5M13.75 17.5V5.16667C13.75 4.23325 13.75 3.76654 13.5683 3.41002C13.4085 3.09641 13.1535 2.84144 12.8399 2.68166C12.4834 2.5 12.0167 2.5 11.0833 2.5H8.91663C7.98321 2.5 7.5165 2.5 7.15998 2.68166C6.84637 2.84144 6.5914 3.09641 6.43162 3.41002C6.24996 3.76654 6.24996 4.23325 6.24996 5.16667V17.5M18.3333 17.5H1.66663M9.16663 5.83333H10.8333M9.16663 9.16667H10.8333M9.16663 12.5H10.8333"
        stroke="#1369E9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  papper_tick_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6667 10.4167V5.66675C16.6667 4.26662 16.6667 3.56655 16.3942 3.03177C16.1545 2.56137 15.7721 2.17892 15.3017 1.93923C14.7669 1.66675 14.0668 1.66675 12.6667 1.66675H7.33337C5.93324 1.66675 5.23318 1.66675 4.6984 1.93923C4.22799 2.17892 3.84554 2.56137 3.60586 3.03177C3.33337 3.56655 3.33337 4.26662 3.33337 5.66675V14.3334C3.33337 15.7335 3.33337 16.4336 3.60586 16.9684C3.84554 17.4388 4.22799 17.8212 4.6984 18.0609C5.23318 18.3334 5.93324 18.3334 7.33337 18.3334H10M11.6667 9.16675H6.66671M8.33337 12.5001H6.66671M13.3334 5.83341H6.66671M12.0834 15.8334L13.75 17.5001L17.5 13.7501"
        stroke="#1369E9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  users_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 13.1974C16.2132 13.8069 17.2534 14.785 18.0127 16.008C18.163 16.2502 18.2382 16.3713 18.2642 16.539C18.317 16.8798 18.084 17.2988 17.7666 17.4336C17.6104 17.5 17.4347 17.5 17.0833 17.5M13.3333 9.6102C14.5681 8.99657 15.4167 7.72238 15.4167 6.25C15.4167 4.77762 14.5681 3.50343 13.3333 2.8898M11.6667 6.25C11.6667 8.32107 9.98772 10 7.91665 10C5.84559 10 4.16665 8.32107 4.16665 6.25C4.16665 4.17893 5.84559 2.5 7.91665 2.5C9.98772 2.5 11.6667 4.17893 11.6667 6.25ZM2.13268 15.782C3.46127 13.7871 5.5578 12.5 7.91665 12.5C10.2755 12.5 12.372 13.7871 13.7006 15.782C13.9917 16.219 14.1372 16.4375 14.1205 16.7166C14.1074 16.9339 13.9649 17.2 13.7913 17.3313C13.5683 17.5 13.2615 17.5 12.648 17.5H3.18528C2.5718 17.5 2.26505 17.5 2.04202 17.3313C1.86836 17.2 1.72589 16.9339 1.71285 16.7166C1.69609 16.4375 1.84162 16.219 2.13268 15.782Z"
        stroke="#1369E9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  workorder_icon_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_270_5601)">
        <path
          d="M1.66663 9.99997L9.70182 14.0176C9.81114 14.0722 9.86579 14.0996 9.92313 14.1103C9.97391 14.1198 10.026 14.1198 10.0768 14.1103C10.1341 14.0996 10.1888 14.0722 10.2981 14.0176L18.3333 9.99997M1.66663 14.1666L9.70182 18.1842C9.81114 18.2389 9.86579 18.2662 9.92313 18.277C9.97391 18.2865 10.026 18.2865 10.0768 18.277C10.1341 18.2662 10.1888 18.2389 10.2981 18.1842L18.3333 14.1666M1.66663 5.83331L9.70182 1.81571C9.81114 1.76105 9.86579 1.73372 9.92313 1.72297C9.97391 1.71344 10.026 1.71344 10.0768 1.72297C10.1341 1.73372 10.1888 1.76105 10.2981 1.81571L18.3333 5.83331L10.2981 9.8509C10.1888 9.90556 10.1341 9.93289 10.0768 9.94365C10.026 9.95317 9.97391 9.95317 9.92313 9.94365C9.86579 9.93289 9.81114 9.90556 9.70182 9.8509L1.66663 5.83331Z"
          stroke="#1369E9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_270_5601">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  save_icon_white: (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 1.25V3.8C3.75 4.22004 3.75 4.43006 3.83175 4.59049C3.90365 4.73161 4.01839 4.84635 4.15951 4.91825C4.31994 5 4.52996 5 4.95 5H10.05C10.47 5 10.6801 5 10.8405 4.91825C10.9816 4.84635 11.0964 4.73161 11.1683 4.59049C11.25 4.43006 11.25 4.22004 11.25 3.8V2M11.25 14.75V9.95C11.25 9.52996 11.25 9.31994 11.1683 9.15951C11.0964 9.01839 10.9816 8.90365 10.8405 8.83175C10.6801 8.75 10.47 8.75 10.05 8.75H4.95C4.52996 8.75 4.31994 8.75 4.15951 8.83175C4.01839 8.90365 3.90365 9.01839 3.83175 9.15951C3.75 9.31994 3.75 9.52996 3.75 9.95V14.75M14.25 5.99411V11.15C14.25 12.4101 14.25 13.0402 14.0048 13.5215C13.789 13.9448 13.4448 14.289 13.0215 14.5048C12.5402 14.75 11.9101 14.75 10.65 14.75H4.35C3.08988 14.75 2.45982 14.75 1.97852 14.5048C1.55516 14.289 1.21095 13.9448 0.995235 13.5215C0.75 13.0402 0.75 12.4101 0.75 11.15V4.85C0.75 3.58988 0.75 2.95982 0.995235 2.47852C1.21095 2.05516 1.55516 1.71095 1.97852 1.49524C2.45982 1.25 3.08988 1.25 4.35 1.25H9.50589C9.87277 1.25 10.0562 1.25 10.2288 1.29145C10.3819 1.32819 10.5282 1.3888 10.6624 1.47104C10.8138 1.5638 10.9435 1.69352 11.2029 1.95294L13.5471 4.29706C13.8065 4.55648 13.9362 4.6862 14.029 4.83757C14.1112 4.97178 14.1718 5.1181 14.2086 5.27115C14.25 5.44378 14.25 5.62723 14.25 5.99411Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  save_icon_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66667 2V4.26667C4.66667 4.64004 4.66667 4.82672 4.73933 4.96933C4.80324 5.09477 4.90523 5.19676 5.03067 5.26067C5.17328 5.33333 5.35997 5.33333 5.73333 5.33333H10.2667C10.64 5.33333 10.8267 5.33333 10.9693 5.26067C11.0948 5.19676 11.1968 5.09477 11.2607 4.96933C11.3333 4.82672 11.3333 4.64004 11.3333 4.26667V2.66667M11.3333 14V9.73333C11.3333 9.35997 11.3333 9.17328 11.2607 9.03067C11.1968 8.90523 11.0948 8.80324 10.9693 8.73933C10.8267 8.66667 10.64 8.66667 10.2667 8.66667H5.73333C5.35997 8.66667 5.17328 8.66667 5.03067 8.73933C4.90523 8.80324 4.80324 8.90523 4.73933 9.03067C4.66667 9.17328 4.66667 9.35997 4.66667 9.73333V14M14 6.21699V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.0799 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H9.78301C10.1091 2 10.2722 2 10.4256 2.03684C10.5617 2.0695 10.6918 2.12337 10.811 2.19648C10.9456 2.27894 11.0609 2.39424 11.2915 2.62484L13.3752 4.7085C13.6058 4.9391 13.7211 5.0544 13.8035 5.18895C13.8766 5.30825 13.9305 5.43831 13.9632 5.57436C14 5.72781 14 5.89087 14 6.21699Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendar_plus_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 6H2.25M12 1.5V3.75M6 1.5V3.75M9 13.5V9M6.75 11.25H11.25M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z"
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arrow_sent_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.87513 10.1251L15.7501 2.25013M7.97082 10.3712L9.9419 15.4397C10.1155 15.8862 10.2024 16.1094 10.3275 16.1746C10.4359 16.2311 10.5651 16.2312 10.6736 16.1748C10.7988 16.1098 10.8859 15.8866 11.06 15.4403L16.0028 2.77453C16.16 2.37164 16.2386 2.1702 16.1956 2.04148C16.1583 1.92969 16.0706 1.84197 15.9588 1.80462C15.8301 1.76162 15.6286 1.84023 15.2257 1.99746L2.55992 6.94021C2.11362 7.11438 1.89046 7.20146 1.82543 7.32664C1.76906 7.43516 1.76913 7.56434 1.82563 7.67279C1.89081 7.7979 2.11407 7.88472 2.56058 8.05836L7.62908 10.0294C7.71972 10.0647 7.76504 10.0823 7.8032 10.1095C7.83702 10.1337 7.8666 10.1632 7.89072 10.1971C7.91794 10.2352 7.93557 10.2805 7.97082 10.3712Z"
        stroke="#98A2B3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  star_nav_fav_icon_green_fill: (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.46199 1.59041C7.63485 1.24021 7.72128 1.06511 7.83862 1.00916C7.94071 0.960487 8.05932 0.960487 8.1614 1.00916C8.27874 1.06511 8.36517 1.24021 8.53804 1.59041L10.178 4.91289C10.2291 5.01628 10.2546 5.06797 10.2919 5.10811C10.3249 5.14365 10.3645 5.17244 10.4085 5.19289C10.4582 5.21599 10.5152 5.22433 10.6293 5.24101L14.2977 5.77721C14.684 5.83367 14.8772 5.8619 14.9666 5.95625C15.0444 6.03835 15.0809 6.15115 15.0661 6.26326C15.0491 6.39211 14.9093 6.52831 14.6296 6.80071L11.9761 9.38524C11.8934 9.46581 11.852 9.50609 11.8253 9.55402C11.8017 9.59646 11.7865 9.64309 11.7807 9.69131C11.7741 9.74577 11.7838 9.80267 11.8034 9.91648L12.4295 13.567C12.4955 13.952 12.5285 14.1446 12.4665 14.2588C12.4125 14.3582 12.3165 14.4279 12.2053 14.4485C12.0775 14.4722 11.9046 14.3813 11.5588 14.1995L8.27928 12.4748C8.1771 12.4211 8.12601 12.3942 8.07218 12.3836C8.02452 12.3743 7.9755 12.3743 7.92784 12.3836C7.87402 12.3942 7.82293 12.4211 7.72074 12.4748L4.44119 14.1995C4.09544 14.3813 3.92256 14.4722 3.79473 14.4485C3.68351 14.4279 3.58754 14.3582 3.53355 14.2588C3.4715 14.1446 3.50452 13.952 3.57056 13.567L4.19666 9.91648C4.21618 9.80267 4.22594 9.74577 4.21934 9.69131C4.21349 9.64309 4.19833 9.59646 4.1747 9.55402C4.14802 9.50609 4.10666 9.46581 4.02394 9.38524L1.37042 6.80071C1.09075 6.52831 0.950911 6.39211 0.933895 6.26326C0.91909 6.15115 0.955665 6.03835 1.03344 5.95625C1.12283 5.8619 1.31598 5.83367 1.70228 5.77721L5.37073 5.24101C5.48482 5.22433 5.54186 5.21599 5.59154 5.19289C5.63552 5.17244 5.67512 5.14365 5.70814 5.10811C5.74543 5.06797 5.77095 5.01628 5.82198 4.91289L7.46199 1.59041Z"
        fill="#28B97B"
        stroke="#28B97B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dashboard_nav_icon_white: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M12.9 10.5003C13.1078 10.5003 13.2116 10.5002 13.2958 10.5464C13.3653 10.5844 13.4299 10.6559 13.4608 10.7288C13.4983 10.8172 13.4889 10.9112 13.47 11.0993C13.3722 12.0743 13.0366 13.0138 12.4888 13.8337C11.8295 14.8204 10.8925 15.5894 9.7961 16.0435C8.69975 16.4977 7.49335 16.6165 6.32946 16.385C5.16557 16.1535 4.09648 15.582 3.25736 14.7429C2.41825 13.9038 1.8468 12.8347 1.61529 11.6708C1.38378 10.5069 1.5026 9.30051 1.95673 8.20415C2.41085 7.10779 3.17989 6.17072 4.16658 5.51143C4.98642 4.96363 5.92594 4.62805 6.90098 4.53022C7.08905 4.51135 7.18309 4.50192 7.27146 4.53941C7.34437 4.57034 7.41582 4.63499 7.45387 4.70444C7.5 4.78863 7.5 4.8925 7.5 5.10025V9.90025C7.5 10.1103 7.5 10.2153 7.54088 10.2955C7.57683 10.3661 7.6342 10.4234 7.70476 10.4594C7.78497 10.5003 7.88998 10.5003 8.1 10.5003H12.9Z"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 2.10025C10.5 1.8925 10.5 1.78862 10.5461 1.70443C10.5842 1.63498 10.6556 1.57034 10.7285 1.53941C10.8169 1.50191 10.9109 1.51134 11.099 1.53021C12.4703 1.66776 13.7595 2.27448 14.7426 3.25761C15.7258 4.24074 16.3325 5.52992 16.47 6.90123C16.4889 7.0893 16.4983 7.18334 16.4608 7.27171C16.4299 7.34462 16.3653 7.41607 16.2958 7.45412C16.2116 7.50025 16.1078 7.50025 15.9 7.50025L11.1 7.50025C10.89 7.50025 10.785 7.50025 10.7048 7.45938C10.6342 7.42342 10.5768 7.36606 10.5409 7.2955C10.5 7.21528 10.5 7.11027 10.5 6.90025V2.10025Z"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2374_8833">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  workorder_nav_icon_white: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 9L8.73167 12.6158C8.83006 12.665 8.87925 12.6896 8.93085 12.6993C8.97655 12.7079 9.02345 12.7079 9.06915 12.6993C9.12075 12.6896 9.16994 12.665 9.26833 12.6158L16.5 9M1.5 12.75L8.73167 16.3658C8.83006 16.415 8.87925 16.4396 8.93085 16.4493C8.97655 16.4579 9.02345 16.4579 9.06915 16.4493C9.12075 16.4396 9.16994 16.415 9.26833 16.3658L16.5 12.75M1.5 5.25L8.73167 1.63417C8.83006 1.58497 8.87925 1.56038 8.93085 1.5507C8.97655 1.54212 9.02345 1.54212 9.06915 1.5507C9.12075 1.56038 9.16994 1.58497 9.26833 1.63417L16.5 5.25L9.26833 8.86584C9.16994 8.91503 9.12075 8.93963 9.06915 8.94931C9.02345 8.95788 8.97655 8.95788 8.93085 8.94931C8.87925 8.93963 8.83006 8.91503 8.73167 8.86584L1.5 5.25Z"
        stroke="white"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  organization_nav_icon_white: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.625 8.25H3.45C3.02996 8.25 2.81994 8.25 2.65951 8.33175C2.51839 8.40365 2.40365 8.51839 2.33175 8.65951C2.25 8.81994 2.25 9.02996 2.25 9.45V15.75M12.375 8.25H14.55C14.97 8.25 15.1801 8.25 15.3405 8.33175C15.4816 8.40365 15.5963 8.51839 15.6683 8.65951C15.75 8.81994 15.75 9.02996 15.75 9.45V15.75M12.375 15.75V4.65C12.375 3.80992 12.375 3.38988 12.2115 3.06901C12.0677 2.78677 11.8382 2.5573 11.556 2.41349C11.2351 2.25 10.8151 2.25 9.975 2.25H8.025C7.18492 2.25 6.76488 2.25 6.44401 2.41349C6.16177 2.5573 5.9323 2.78677 5.78849 3.06901C5.625 3.38988 5.625 3.80992 5.625 4.65V15.75M16.5 15.75H1.5M8.25 5.25H9.75M8.25 8.25H9.75M8.25 11.25H9.75"
        stroke="white"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  wrench_nav_icon_white: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7235 5.72353C11.4265 5.42652 11.278 5.27801 11.2224 5.10676C11.1734 4.95613 11.1734 4.79387 11.2224 4.64324C11.278 4.47199 11.4265 4.32348 11.7235 4.02647L13.8523 1.89769C13.2874 1.64222 12.6603 1.5 12 1.5C9.51471 1.5 7.49999 3.51472 7.49999 6C7.49999 6.36828 7.54423 6.72623 7.62768 7.06882C7.71705 7.43568 7.76174 7.61911 7.7538 7.735C7.7455 7.85632 7.72741 7.92087 7.67146 8.02884C7.61802 8.13197 7.51563 8.23436 7.31085 8.43914L2.62499 13.125C2.00367 13.7463 2.00367 14.7537 2.62499 15.375C3.24631 15.9963 4.25367 15.9963 4.87499 15.375L9.56085 10.6891C9.76563 10.4844 9.86802 10.382 9.97115 10.3285C10.0791 10.2726 10.1437 10.2545 10.265 10.2462C10.3809 10.2382 10.5643 10.2829 10.9312 10.3723C11.2738 10.4558 11.6317 10.5 12 10.5C14.4853 10.5 16.5 8.48528 16.5 6C16.5 5.33969 16.3578 4.71261 16.1023 4.14769L13.9735 6.27647C13.6765 6.57348 13.528 6.72199 13.3567 6.77763C13.2061 6.82658 13.0439 6.82658 12.8932 6.77763C12.722 6.72199 12.5735 6.57348 12.2765 6.27647L11.7235 5.72353Z"
        stroke="white"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  report_nav_icon_white: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 1.5C9.98491 1.5 10.9602 1.69399 11.8701 2.0709C12.7801 2.44781 13.6069 3.00026 14.3033 3.6967C14.9997 4.39314 15.5522 5.21994 15.9291 6.12988C16.306 7.03982 16.5 8.01509 16.5 9.00001M9 1.5V9M9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9.00001M9 1.5C13.1421 1.5 16.5 4.85787 16.5 9.00001M16.5 9.00001L9 9M16.5 9.00001C16.5 10.1836 16.2199 11.3504 15.6825 12.4049C15.1452 13.4595 14.3659 14.3719 13.4084 15.0676L9 9"
        stroke="white"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  settings_nav_icon_white: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
        stroke="white"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0455 11.0455C13.9547 11.2511 13.9276 11.4792 13.9677 11.7004C14.0078 11.9216 14.1133 12.1257 14.2705 12.2864L14.3114 12.3273C14.4382 12.4539 14.5387 12.6043 14.6074 12.7699C14.676 12.9354 14.7113 13.1128 14.7113 13.292C14.7113 13.4712 14.676 13.6487 14.6074 13.8142C14.5387 13.9798 14.4382 14.1302 14.3114 14.2568C14.1847 14.3836 14.0343 14.4842 13.8688 14.5528C13.7032 14.6214 13.5258 14.6568 13.3466 14.6568C13.1674 14.6568 12.9899 14.6214 12.8244 14.5528C12.6589 14.4842 12.5085 14.3836 12.3818 14.2568L12.3409 14.2159C12.1802 14.0587 11.9761 13.9533 11.7549 13.9132C11.5338 13.8731 11.3056 13.9001 11.1 13.9909C10.8983 14.0773 10.7264 14.2208 10.6052 14.4038C10.4841 14.5867 10.4191 14.8011 10.4182 15.0205V15.1364C10.4182 15.498 10.2745 15.8449 10.0188 16.1006C9.76305 16.3563 9.4162 16.5 9.05455 16.5C8.69289 16.5 8.34604 16.3563 8.09031 16.1006C7.83458 15.8449 7.69091 15.498 7.69091 15.1364V15.075C7.68563 14.8493 7.61258 14.6305 7.48126 14.4468C7.34993 14.2632 7.16641 14.1234 6.95455 14.0455C6.7489 13.9547 6.52078 13.9276 6.2996 13.9677C6.07842 14.0078 5.87433 14.1133 5.71364 14.2705L5.67273 14.3114C5.54608 14.4382 5.39569 14.5387 5.23015 14.6074C5.0646 14.676 4.88716 14.7113 4.70795 14.7113C4.52875 14.7113 4.35131 14.676 4.18576 14.6074C4.02022 14.5387 3.86983 14.4382 3.74318 14.3114C3.6164 14.1847 3.51582 14.0343 3.44719 13.8688C3.37857 13.7032 3.34325 13.5258 3.34325 13.3466C3.34325 13.1674 3.37857 12.9899 3.44719 12.8244C3.51582 12.6589 3.6164 12.5085 3.74318 12.3818L3.78409 12.3409C3.94128 12.1802 4.04672 11.9761 4.08682 11.7549C4.12693 11.5338 4.09985 11.3056 4.00909 11.1C3.92266 10.8983 3.77915 10.7264 3.59623 10.6052C3.4133 10.4841 3.19895 10.4191 2.97955 10.4182H2.86364C2.50198 10.4182 2.15513 10.2745 1.8994 10.0188C1.64367 9.76305 1.5 9.4162 1.5 9.05455C1.5 8.69289 1.64367 8.34604 1.8994 8.09031C2.15513 7.83458 2.50198 7.69091 2.86364 7.69091H2.925C3.15068 7.68563 3.36955 7.61258 3.55316 7.48126C3.73677 7.34993 3.87662 7.16641 3.95455 6.95455C4.04531 6.7489 4.07238 6.52078 4.03228 6.2996C3.99217 6.07842 3.88673 5.87433 3.72955 5.71364L3.68864 5.67273C3.56185 5.54608 3.46127 5.39569 3.39265 5.23015C3.32402 5.0646 3.2887 4.88716 3.2887 4.70795C3.2887 4.52875 3.32402 4.35131 3.39265 4.18576C3.46127 4.02022 3.56185 3.86983 3.68864 3.74318C3.81528 3.6164 3.96568 3.51582 4.13122 3.44719C4.29676 3.37857 4.47421 3.34325 4.65341 3.34325C4.83261 3.34325 5.01006 3.37857 5.1756 3.44719C5.34114 3.51582 5.49154 3.6164 5.61818 3.74318L5.65909 3.78409C5.81978 3.94128 6.02387 4.04672 6.24505 4.08682C6.46623 4.12693 6.69435 4.09985 6.9 4.00909H6.95455C7.15621 3.92266 7.32819 3.77915 7.44934 3.59623C7.57048 3.4133 7.63549 3.19895 7.63636 2.97955V2.86364C7.63636 2.50198 7.78003 2.15513 8.03576 1.8994C8.2915 1.64367 8.63834 1.5 9 1.5C9.36166 1.5 9.7085 1.64367 9.96424 1.8994C10.22 2.15513 10.3636 2.50198 10.3636 2.86364V2.925C10.3645 3.1444 10.4295 3.35876 10.5507 3.54168C10.6718 3.72461 10.8438 3.86812 11.0455 3.95455C11.2511 4.04531 11.4792 4.07238 11.7004 4.03228C11.9216 3.99217 12.1257 3.88673 12.2864 3.72955L12.3273 3.68864C12.4539 3.56185 12.6043 3.46127 12.7699 3.39265C12.9354 3.32402 13.1128 3.2887 13.292 3.2887C13.4712 3.2887 13.6487 3.32402 13.8142 3.39265C13.9798 3.46127 14.1302 3.56185 14.2568 3.68864C14.3836 3.81528 14.4842 3.96568 14.5528 4.13122C14.6214 4.29676 14.6568 4.47421 14.6568 4.65341C14.6568 4.83261 14.6214 5.01006 14.5528 5.1756C14.4842 5.34114 14.3836 5.49154 14.2568 5.61818L14.2159 5.65909C14.0587 5.81978 13.9533 6.02387 13.9132 6.24505C13.8731 6.46623 13.9001 6.69435 13.9909 6.9V6.95455C14.0773 7.15621 14.2208 7.32819 14.4038 7.44934C14.5867 7.57048 14.8011 7.63549 15.0205 7.63636H15.1364C15.498 7.63636 15.8449 7.78003 16.1006 8.03576C16.3563 8.2915 16.5 8.63834 16.5 9C16.5 9.36166 16.3563 9.7085 16.1006 9.96424C15.8449 10.22 15.498 10.3636 15.1364 10.3636H15.075C14.8556 10.3645 14.6412 10.4295 14.4583 10.5507C14.2754 10.6718 14.1319 10.8438 14.0455 11.0455Z"
        stroke="white"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  user_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.98722 14.5788C4.44347 13.5039 5.50869 12.75 6.75 12.75H11.25C12.4913 12.75 13.5565 13.5039 14.0128 14.5788M12 7.125C12 8.78185 10.6569 10.125 9 10.125C7.34315 10.125 6 8.78185 6 7.125C6 5.46815 7.34315 4.125 9 4.125C10.6569 4.125 12 5.46815 12 7.125ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="#A5AAAF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  signout_icon_black: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 11.25V12.15C15.75 13.4101 15.75 14.0402 15.5048 14.5215C15.289 14.9448 14.9448 15.289 14.5215 15.5048C14.0402 15.75 13.4101 15.75 12.15 15.75H5.85C4.58988 15.75 3.95982 15.75 3.47852 15.5048C3.05516 15.289 2.71095 14.9448 2.49524 14.5215C2.25 14.0402 2.25 13.4101 2.25 12.15V11.25M12.75 7.5L9 11.25M9 11.25L5.25 7.5M9 11.25V2.25"
        stroke="#9DA2A7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  user_icon_white: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3388_17464)">
        <path
          d="M3.98722 14.5788C4.44347 13.5039 5.50869 12.75 6.75 12.75H11.25C12.4913 12.75 13.5565 13.5039 14.0128 14.5788M12 7.125C12 8.78185 10.6569 10.125 9 10.125C7.34315 10.125 6 8.78185 6 7.125C6 5.46815 7.34315 4.125 9 4.125C10.6569 4.125 12 5.46815 12 7.125ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3388_17464">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  two_left_arrow_icon_white: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 12.75L9.75 9L13.5 5.25M8.25 12.75L4.5 9L8.25 5.25"
        stroke="white"
        strokeOpacity="0.3"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  google_icon: (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_426_11376" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
        <path
          d="M14.8256 6.60475H7.67442V9.56987H11.7907C11.407 11.4536 9.80233 12.535 7.67442 12.535C5.16279 12.535 3.13953 10.5117 3.13953 8.0001C3.13953 5.48847 5.16279 3.46522 7.67442 3.46522C8.75581 3.46522 9.73256 3.84894 10.5 4.47685L12.7326 2.24429C11.3721 1.05824 9.62791 0.325684 7.67442 0.325684C3.4186 0.325684 0 3.74429 0 8.0001C0 12.2559 3.4186 15.6745 7.67442 15.6745C11.5116 15.6745 15 12.8838 15 8.0001C15 7.54661 14.9302 7.05824 14.8256 6.60475Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_426_11376)">
        <path d="M-0.697754 12.5351V3.46533L5.23248 8.00022L-0.697754 12.5351Z" fill="#FBBC05" />
      </g>
      <mask id="mask1_426_11376" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
        <path
          d="M14.8256 6.60475H7.67442V9.56987H11.7907C11.407 11.4536 9.80233 12.535 7.67442 12.535C5.16279 12.535 3.13953 10.5117 3.13953 8.0001C3.13953 5.48847 5.16279 3.46522 7.67442 3.46522C8.75581 3.46522 9.73256 3.84894 10.5 4.47685L12.7326 2.24429C11.3721 1.05824 9.62791 0.325684 7.67442 0.325684C3.4186 0.325684 0 3.74429 0 8.0001C0 12.2559 3.4186 15.6745 7.67442 15.6745C11.5116 15.6745 15 12.8838 15 8.0001C15 7.54661 14.9302 7.05824 14.8256 6.60475Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_426_11376)">
        <path
          d="M-0.697754 3.46514L5.23248 8.00002L7.67434 5.87212L16.0464 4.51165V-0.37207H-0.697754V3.46514Z"
          fill="#EA4335"
        />
      </g>
      <mask id="mask2_426_11376" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
        <path
          d="M14.8256 6.60475H7.67442V9.56987H11.7907C11.407 11.4536 9.80233 12.535 7.67442 12.535C5.16279 12.535 3.13953 10.5117 3.13953 8.0001C3.13953 5.48847 5.16279 3.46522 7.67442 3.46522C8.75581 3.46522 9.73256 3.84894 10.5 4.47685L12.7326 2.24429C11.3721 1.05824 9.62791 0.325684 7.67442 0.325684C3.4186 0.325684 0 3.74429 0 8.0001C0 12.2559 3.4186 15.6745 7.67442 15.6745C11.5116 15.6745 15 12.8838 15 8.0001C15 7.54661 14.9302 7.05824 14.8256 6.60475Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_426_11376)">
        <path
          d="M-0.697754 12.5349L9.76736 4.51165L12.5232 4.86049L16.0464 -0.37207V16.3721H-0.697754V12.5349Z"
          fill="#34A853"
        />
      </g>
      <mask id="mask3_426_11376" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
        <path
          d="M14.8256 6.60475H7.67442V9.56987H11.7907C11.407 11.4536 9.80233 12.535 7.67442 12.535C5.16279 12.535 3.13953 10.5117 3.13953 8.0001C3.13953 5.48847 5.16279 3.46522 7.67442 3.46522C8.75581 3.46522 9.73256 3.84894 10.5 4.47685L12.7326 2.24429C11.3721 1.05824 9.62791 0.325684 7.67442 0.325684C3.4186 0.325684 0 3.74429 0 8.0001C0 12.2559 3.4186 15.6745 7.67442 15.6745C11.5116 15.6745 15 12.8838 15 8.0001C15 7.54661 14.9302 7.05824 14.8256 6.60475Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_426_11376)">
        <path
          d="M16.0467 16.3723L5.23275 8.00022L3.8374 6.9537L16.0467 3.46533V16.3723Z"
          fill="#4285F4"
        />
      </g>
    </svg>
  ),
  microsoft_icon: (
    <svg width="16" height="17" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0.839111H9.50377V10.3429H0V0.839111Z" fill="#F25022" />
      <path d="M10.4963 0.839111H20.0001V10.3429H10.4963V0.839111Z" fill="#7FBA00" />
      <path d="M0 11.3353H9.50377V20.8391H0V11.3353Z" fill="#00A4EF" />
      <path d="M10.4963 11.3353H20.0001V20.8391H10.4963V11.3353Z" fill="#FFB900" />
    </svg>
  ),
  loader_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="loader"
    >
      <path
        d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
        opacity=".10"
      />
      <path
        d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
        className="spinner-bg-overlay"
      />
    </svg>
  ),
  down_arrow_icon_black: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 2.91666V11.0833M7 11.0833L11.0833 6.99999M7 11.0833L2.91667 6.99999"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sort_icon: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 7.5L6 10L8.5 7.5M3.5 4.5L6 2L8.5 4.5"
        stroke="#344054"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sort_up_icon_black: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 7.5L6 4.5L3 7.5" stroke="#344054" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  sort_down_icon_black: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 4.5L6 7.5L9 4.5" stroke="#344054" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  sparkles_blue: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0166 2.50039C16.0166 2.16902 15.7479 1.90039 15.4166 1.90039C15.0852 1.90039 14.8166 2.16902 14.8166 2.50039V3.98372H13.3332C13.0019 3.98372 12.7332 4.25235 12.7332 4.58372C12.7332 4.91509 13.0019 5.18372 13.3332 5.18372H14.8166V6.66706C14.8166 6.99843 15.0852 7.26706 15.4166 7.26706C15.7479 7.26706 16.0166 6.99843 16.0166 6.66706V5.18372H17.4999C17.8313 5.18372 18.0999 4.91509 18.0999 4.58372C18.0999 4.25235 17.8313 3.98372 17.4999 3.98372H16.0166V2.50039ZM8.89324 5.61834C8.80412 5.38662 8.5815 5.23372 8.33323 5.23372C8.08497 5.23372 7.86235 5.38662 7.77323 5.61834L6.79104 8.17202C6.545 8.81173 6.45546 9.03232 6.32682 9.21323C6.20374 9.38633 6.0525 9.53756 5.87941 9.66064C5.6985 9.78928 5.47791 9.87882 4.8382 10.1249L2.28451 11.107C2.0528 11.1962 1.8999 11.4188 1.8999 11.6671C1.8999 11.9153 2.0528 12.1379 2.28451 12.2271L4.8382 13.2093C5.47791 13.4553 5.6985 13.5448 5.87941 13.6735C6.0525 13.7966 6.20374 13.9478 6.32682 14.1209C6.45546 14.3018 6.545 14.5224 6.79104 15.1621L7.77323 17.7158C7.86235 17.9475 8.08497 18.1004 8.33324 18.1004C8.5815 18.1004 8.80412 17.9475 8.89324 17.7158L9.87543 15.1621C10.1215 14.5224 10.211 14.3018 10.3397 14.1209C10.4627 13.9478 10.614 13.7966 10.7871 13.6735C10.968 13.5448 11.1886 13.4553 11.8283 13.2093L14.382 12.2271C14.6137 12.1379 14.7666 11.9153 14.7666 11.6671C14.7666 11.4188 14.6137 11.1962 14.382 11.107L11.8283 10.1249C11.1886 9.87882 10.968 9.78928 10.7871 9.66064C10.614 9.53756 10.4627 9.38633 10.3397 9.21323C10.211 9.03232 10.1215 8.81173 9.87543 8.17202L8.89324 5.61834ZM7.91106 8.60279L8.33324 7.50513L8.75541 8.60279L8.78213 8.67229C8.99126 9.21651 9.1344 9.58899 9.36168 9.90862C9.5625 10.191 9.80925 10.4378 10.0917 10.6386C10.4113 10.8659 10.7838 11.009 11.328 11.2182L11.3975 11.2449L12.4952 11.6671L11.3975 12.0892L11.328 12.1159L11.328 12.116C10.7838 12.3251 10.4113 12.4682 10.0917 12.6955C9.80925 12.8963 9.5625 13.1431 9.36168 13.4255C9.1344 13.7451 8.99126 14.1176 8.78212 14.6618L8.75541 14.7313L8.33324 15.829L7.91106 14.7313L7.88435 14.6618C7.67521 14.1176 7.53207 13.7451 7.30479 13.4255C7.10397 13.1431 6.85722 12.8963 6.5748 12.6955C6.25518 12.4682 5.8827 12.3251 5.33848 12.116L5.33847 12.1159L5.26897 12.0892L4.17131 11.6671L5.26897 11.2449L5.33846 11.2182L5.33848 11.2182C5.8827 11.009 6.25517 10.8659 6.5748 10.6386C6.85722 10.4378 7.10397 10.191 7.30479 9.90862C7.53207 9.58899 7.67521 9.21651 7.88435 8.67228L7.91106 8.60279Z"
        fill="#7A5BF8"
      />
    </svg>
  ),
  circle_tick_icon_green: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="circle-tick-icon-green"
    >
      <path
        d="M5.625 9L7.875 11.25L12.375 6.75M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="#28B97B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_pause_icon_orange: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.125 11.25V6.75M10.875 11.25V6.75M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="#FF6200"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_close_icon_red: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="circle-close-icon-red"
    >
      <path
        d="M11.25 6.75L6.75 11.25M6.75 6.75L11.25 11.25M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="#EA1C1C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_play_icon_red: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        stroke="#1369E9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.125 6.724C7.125 6.36604 7.125 6.18705 7.19981 6.08713C7.265 6.00006 7.36478 5.94558 7.47328 5.93783C7.59779 5.92893 7.74834 6.02572 8.04945 6.21929L11.5899 8.49529C11.8512 8.66326 11.9818 8.74725 12.027 8.85404C12.0664 8.94735 12.0664 9.05265 12.027 9.14596C11.9818 9.25275 11.8512 9.33674 11.5899 9.50471L8.04946 11.7807C7.74834 11.9743 7.59779 12.0711 7.47328 12.0622C7.36478 12.0544 7.265 11.9999 7.19981 11.9129C7.125 11.8129 7.125 11.634 7.125 11.276V6.724Z"
        stroke="#1369E9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rescheduled_icon_white: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.75 5.24935H9.625C11.0747 5.24935 12.25 6.4246 12.25 7.87435C12.25 9.3241 11.0747 10.4993 9.625 10.4993H7M1.75 5.24935L4.08333 2.91602M1.75 5.24935L4.08333 7.58268"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rescheduled_icon_black: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.75 5.24935H9.625C11.0747 5.24935 12.25 6.4246 12.25 7.87435C12.25 9.3241 11.0747 10.4993 9.625 10.4993H7M1.75 5.24935L4.08333 2.91602M1.75 5.24935L4.08333 7.58268"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag_icon_red: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10.5C3.75 10.5 3 11.25 3 11.25V2.25C3 2.25 3.75 1.5 6 1.5C8.25 1.5 9.75 3 12 3C14.25 3 15 2.25 15 2.25V11.25C15 11.25 14.25 12 12 12C9.75 12 8.25 10.5 6 10.5Z"
        fill="#EA1C1C"
      />
      <path
        d="M3 11.25C3 11.25 3.75 10.5 6 10.5C8.25 10.5 9.75 12 12 12C14.25 12 15 11.25 15 11.25V2.25C15 2.25 14.25 3 12 3C9.75 3 8.25 1.5 6 1.5C3.75 1.5 3 2.25 3 2.25L3 16.5"
        stroke="#EA1C1C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag_icon_orange: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10.5C3.75 10.5 3 11.25 3 11.25V2.25C3 2.25 3.75 1.5 6 1.5C8.25 1.5 9.75 3 12 3C14.25 3 15 2.25 15 2.25V11.25C15 11.25 14.25 12 12 12C9.75 12 8.25 10.5 6 10.5Z"
        fill="#FF6200"
      />
      <path
        d="M3 11.25C3 11.25 3.75 10.5 6 10.5C8.25 10.5 9.75 12 12 12C14.25 12 15 11.25 15 11.25V2.25C15 2.25 14.25 3 12 3C9.75 3 8.25 1.5 6 1.5C3.75 1.5 3 2.25 3 2.25L3 16.5"
        stroke="#FF6200"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag_icon_blue: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10.5C3.75 10.5 3 11.25 3 11.25V2.25C3 2.25 3.75 1.5 6 1.5C8.25 1.5 9.75 3 12 3C14.25 3 15 2.25 15 2.25V11.25C15 11.25 14.25 12 12 12C9.75 12 8.25 10.5 6 10.5Z"
        fill="#00AED4"
      />
      <path
        d="M3 11.25C3 11.25 3.75 10.5 6 10.5C8.25 10.5 9.75 12 12 12C14.25 12 15 11.25 15 11.25V2.25C15 2.25 14.25 3 12 3C9.75 3 8.25 1.5 6 1.5C3.75 1.5 3 2.25 3 2.25L3 16.5"
        stroke="#00AED4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag_icon_grey: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10.5C3.75 10.5 3 11.25 3 11.25V2.25C3 2.25 3.75 1.5 6 1.5C8.25 1.5 9.75 3 12 3C14.25 3 15 2.25 15 2.25V11.25C15 11.25 14.25 12 12 12C9.75 12 8.25 10.5 6 10.5Z"
        fill="#98A2B3"
      />
      <path
        d="M3 11.25C3 11.25 3.75 10.5 6 10.5C8.25 10.5 9.75 12 12 12C14.25 12 15 11.25 15 11.25V2.25C15 2.25 14.25 3 12 3C9.75 3 8.25 1.5 6 1.5C3.75 1.5 3 2.25 3 2.25L3 16.5"
        stroke="#98A2B3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag_icon_white_outline: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.3335 8.75033C2.3335 8.75033 2.91683 8.16699 4.66683 8.16699C6.41683 8.16699 7.5835 9.33366 9.3335 9.33366C11.0835 9.33366 11.6668 8.75033 11.6668 8.75033V1.75033C11.6668 1.75033 11.0835 2.33366 9.3335 2.33366C7.5835 2.33366 6.41683 1.16699 4.66683 1.16699C2.91683 1.16699 2.3335 1.75033 2.3335 1.75033L2.3335 12.8337"
        stroke="#FFFFFF"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag_icon_orange_outline: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66602 6.24992C1.66602 6.24992 2.08268 5.83325 3.33268 5.83325C4.58268 5.83325 5.41602 6.66659 6.66602 6.66659C7.91602 6.66659 8.33268 6.24992 8.33268 6.24992V1.24992C8.33268 1.24992 7.91602 1.66659 6.66602 1.66659C5.41602 1.66659 4.58268 0.833252 3.33268 0.833252C2.08268 0.833252 1.66602 1.24992 1.66602 1.24992L1.66602 9.16659"
        stroke="#FF6200"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag_icon_blue_outline: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66602 6.24992C1.66602 6.24992 2.08268 5.83325 3.33268 5.83325C4.58268 5.83325 5.41602 6.66659 6.66602 6.66659C7.91602 6.66659 8.33268 6.24992 8.33268 6.24992V1.24992C8.33268 1.24992 7.91602 1.66659 6.66602 1.66659C5.41602 1.66659 4.58268 0.833252 3.33268 0.833252C2.08268 0.833252 1.66602 1.24992 1.66602 1.24992L1.66602 9.16659"
        stroke="#00AED4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  flag_icon_grey_outline: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66602 6.24992C1.66602 6.24992 2.08268 5.83325 3.33268 5.83325C4.58268 5.83325 5.41602 6.66659 6.66602 6.66659C7.91602 6.66659 8.33268 6.24992 8.33268 6.24992V1.24992C8.33268 1.24992 7.91602 1.66659 6.66602 1.66659C5.41602 1.66659 4.58268 0.833252 3.33268 0.833252C2.08268 0.833252 1.66602 1.24992 1.66602 1.24992L1.66602 9.16659"
        stroke="#98A2B3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_info_icon_blue: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 21.3333V16M16 10.6667H16.0134M29.3334 16C29.3334 23.3638 23.3638 29.3333 16 29.3333C8.63622 29.3333 2.66669 23.3638 2.66669 16C2.66669 8.6362 8.63622 2.66667 16 2.66667C23.3638 2.66667 29.3334 8.6362 29.3334 16Z"
        stroke="#1369E9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  circle_info_icon_orange: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 10.6667V16M16 21.3333H16.0134M29.3334 16C29.3334 23.3638 23.3638 29.3333 16 29.3333C8.63622 29.3333 2.66669 23.3638 2.66669 16C2.66669 8.6362 8.63622 2.66666 16 2.66666C23.3638 2.66666 29.3334 8.6362 29.3334 16Z"
        stroke="#FF6200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  filter_icon_black: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.33334 3.06667C1.33334 2.6933 1.33334 2.50661 1.40601 2.36401C1.46992 2.23856 1.57191 2.13658 1.69735 2.07266C1.83996 2 2.02664 2 2.40001 2H13.6C13.9734 2 14.1601 2 14.3027 2.07266C14.4281 2.13658 14.5301 2.23856 14.594 2.36401C14.6667 2.50661 14.6667 2.6933 14.6667 3.06667V3.51293C14.6667 3.69213 14.6667 3.78173 14.6448 3.86504C14.6254 3.93887 14.5934 4.00882 14.5503 4.07184C14.5017 4.14295 14.434 4.20164 14.2986 4.319L10.0348 8.01434C9.89933 8.1317 9.83162 8.19038 9.78301 8.26149C9.73992 8.32451 9.70798 8.39446 9.68857 8.46829C9.66668 8.55161 9.66668 8.64121 9.66668 8.8204V12.3056C9.66668 12.436 9.66668 12.5011 9.64565 12.5575C9.62707 12.6073 9.59685 12.6519 9.55751 12.6877C9.51299 12.7281 9.45247 12.7524 9.33142 12.8008L7.06475 13.7074C6.81972 13.8054 6.69721 13.8545 6.59886 13.834C6.51285 13.8161 6.43738 13.765 6.38884 13.6918C6.33334 13.6081 6.33334 13.4762 6.33334 13.2122V8.8204C6.33334 8.64121 6.33334 8.55161 6.31145 8.46829C6.29204 8.39446 6.2601 8.32451 6.21702 8.26149C6.1684 8.19038 6.10069 8.1317 5.96527 8.01434L1.70142 4.319C1.566 4.20164 1.49829 4.14295 1.44967 4.07184C1.40659 4.00882 1.37465 3.93887 1.35524 3.86504C1.33334 3.78173 1.33334 3.69213 1.33334 3.51293V3.06667Z"
        stroke="#1D2939"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  calendr_schedule_icon_blue: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.25 5.83366H1.75M9.33333 1.16699V3.50033M4.66667 1.16699V3.50033M4.55 12.8337H9.45C10.4301 12.8337 10.9201 12.8337 11.2945 12.6429C11.6238 12.4751 11.8915 12.2074 12.0593 11.8781C12.25 11.5038 12.25 11.0138 12.25 10.0337V5.13366C12.25 4.15357 12.25 3.66352 12.0593 3.28918C11.8915 2.95989 11.6238 2.69218 11.2945 2.5244C10.9201 2.33366 10.4301 2.33366 9.45 2.33366H4.55C3.56991 2.33366 3.07986 2.33366 2.70552 2.5244C2.37623 2.69218 2.10852 2.95989 1.94074 3.28918C1.75 3.66352 1.75 4.15357 1.75 5.13366V10.0337C1.75 11.0138 1.75 11.5038 1.94074 11.8781C2.10852 12.2074 2.37623 12.4751 2.70552 12.6429C3.07986 12.8337 3.56991 12.8337 4.55 12.8337Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  timer_icon_blue: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6164_37714)">
        <path
          d="M6.99935 3.50033V7.00033L9.33268 8.16699M12.8327 7.00033C12.8327 10.222 10.221 12.8337 6.99935 12.8337C3.77769 12.8337 1.16602 10.222 1.16602 7.00033C1.16602 3.77866 3.77769 1.16699 6.99935 1.16699C10.221 1.16699 12.8327 3.77866 12.8327 7.00033Z"
          stroke="#1369E9"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6164_37714">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  spanner_icon_blue: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.11876 4.45196C8.88775 4.22095 8.77224 4.10544 8.72897 3.97225C8.6909 3.85509 8.6909 3.72889 8.72897 3.61173C8.77224 3.47854 8.88775 3.36304 9.11876 3.13203L10.7745 1.47631C10.3351 1.27761 9.84736 1.16699 9.33379 1.16699C7.4008 1.16699 5.83379 2.734 5.83379 4.66699C5.83379 4.95343 5.8682 5.23183 5.93311 5.49829C6.00262 5.78363 6.03738 5.9263 6.03121 6.01643C6.02475 6.11079 6.01068 6.161 5.96716 6.24498C5.92559 6.32519 5.84596 6.40482 5.68669 6.5641L2.04212 10.2087C1.55888 10.6919 1.55888 11.4754 2.04212 11.9587C2.52537 12.4419 3.30888 12.4419 3.79212 11.9587L7.43669 8.3141C7.59596 8.15482 7.67559 8.07519 7.75581 8.03362C7.83978 7.99011 7.88999 7.97604 7.98435 7.96958C8.07448 7.96341 8.21715 7.99816 8.50249 8.06767C8.76895 8.13258 9.04735 8.16699 9.33379 8.16699C11.2668 8.16699 12.8338 6.59999 12.8338 4.66699C12.8338 4.15342 12.7232 3.66568 12.5245 3.22631L10.8688 4.88203C10.6377 5.11304 10.5222 5.22854 10.3891 5.27182C10.2719 5.30988 10.1457 5.30988 10.0285 5.27182C9.89534 5.22854 9.77983 5.11304 9.54882 4.88203L9.11876 4.45196Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  timer_v2_icon_blue: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.00033 5.54102V7.87435L8.45866 8.74935M7.00033 2.91602C4.26191 2.91602 2.04199 5.13594 2.04199 7.87435C2.04199 10.6128 4.26191 12.8327 7.00033 12.8327C9.73874 12.8327 11.9587 10.6128 11.9587 7.87435C11.9587 5.13594 9.73874 2.91602 7.00033 2.91602ZM7.00033 2.91602V1.16602M5.83366 1.16602H8.16699M11.8589 3.26137L10.9839 2.38637L11.4214 2.82387M2.14175 3.26137L3.01675 2.38637L2.57925 2.82387"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  clock_icon_blue: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3479_748)">
        <path
          d="M6 3V6L8 7M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
          stroke="#1369E9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3479_748">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  workorder_details_icon_black: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 12.0001L11.6422 16.8212C11.7734 16.8868 11.839 16.9196 11.9078 16.9325C11.9687 16.9439 12.0313 16.9439 12.0922 16.9325C12.161 16.9196 12.2266 16.8868 12.3578 16.8212L22 12.0001M2 17.0001L11.6422 21.8212C11.7734 21.8868 11.839 21.9196 11.9078 21.9325C11.9687 21.9439 12.0313 21.9439 12.0922 21.9325C12.161 21.9196 12.2266 21.8868 12.3578 21.8212L22 17.0001M2 7.00006L11.6422 2.17895C11.7734 2.11336 11.839 2.08056 11.9078 2.06766C11.9687 2.05622 12.0313 2.05622 12.0922 2.06766C12.161 2.08056 12.2266 2.11336 12.3578 2.17895L22 7.00006L12.3578 11.8212C12.2266 11.8868 12.161 11.9196 12.0922 11.9325C12.0313 11.9439 11.9687 11.9439 11.9078 11.9325C11.839 11.9196 11.7734 11.8868 11.6422 11.8212L2 7.00006Z"
        stroke="#101828"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  workorder_menu_icon_blue: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.25 9L7.25 9M16.25 4.5L7.25 4.5M16.25 13.5L7.25 13.5M4.25 9C4.25 9.41421 3.91421 9.75 3.5 9.75C3.08579 9.75 2.75 9.41421 2.75 9C2.75 8.58579 3.08579 8.25 3.5 8.25C3.91421 8.25 4.25 8.58579 4.25 9ZM4.25 4.5C4.25 4.91421 3.91421 5.25 3.5 5.25C3.08579 5.25 2.75 4.91421 2.75 4.5C2.75 4.08579 3.08579 3.75 3.5 3.75C3.91421 3.75 4.25 4.08579 4.25 4.5ZM4.25 13.5C4.25 13.9142 3.91421 14.25 3.5 14.25C3.08579 14.25 2.75 13.9142 2.75 13.5C2.75 13.0858 3.08579 12.75 3.5 12.75C3.91421 12.75 4.25 13.0858 4.25 13.5Z"
        stroke="#1369E9"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  invoice_menu_icon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33366 1.51302V4.26671C9.33366 4.64008 9.33366 4.82676 9.40632 4.96937C9.47024 5.09481 9.57222 5.1968 9.69766 5.26071C9.84027 5.33338 10.027 5.33338 10.4003 5.33338H13.154M9.33366 1.33333H5.86699C4.74689 1.33333 4.18683 1.33333 3.75901 1.55132C3.38269 1.74306 3.07673 2.04902 2.88498 2.42535C2.66699 2.85317 2.66699 3.41322 2.66699 4.53333V11.4667C2.66699 12.5868 2.66699 13.1468 2.88498 13.5746C3.07673 13.951 3.38269 14.2569 3.75901 14.4487C4.18683 14.6667 4.74689 14.6667 5.86699 14.6667H10.1337C11.2538 14.6667 11.8138 14.6667 12.2416 14.4487C12.618 14.2569 12.9239 13.951 13.1157 13.5746C13.3337 13.1468 13.3337 12.5868 13.3337 11.4667V5.33333L9.33366 1.33333Z"
        stroke="#1058C3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.56445 10.4274C6.56445 10.956 6.99304 11.3846 7.52172 11.3846H8.41061C8.97705 11.3846 9.43625 10.9254 9.43625 10.359C9.43625 9.79253 8.97705 9.33334 8.41061 9.33334H7.59009C7.02365 9.33334 6.56445 8.87414 6.56445 8.3077C6.56445 7.74125 7.02365 7.28206 7.59009 7.28206H8.47898C9.00767 7.28206 9.43625 7.71064 9.43625 8.23932M8.00035 6.66667V7.28206M8.00035 11.3846V12"
        stroke="#1058C3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  quote_menu_icon: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.25 15.75H10.25M2.375 16.125L6.53695 14.5242C6.80316 14.4219 6.93626 14.3707 7.06079 14.3038C7.1714 14.2444 7.27685 14.1759 7.37603 14.099C7.48769 14.0123 7.58853 13.9115 7.79021 13.7098L16.25 5.25C17.0784 4.42157 17.0784 3.07843 16.25 2.25C15.4216 1.42157 14.0784 1.42157 13.25 2.25L4.79021 10.7098C4.58853 10.9115 4.48769 11.0123 4.40104 11.124C4.32408 11.2231 4.25555 11.3286 4.19618 11.4392C4.12933 11.5637 4.07814 11.6968 3.97575 11.9631L2.375 16.125ZM2.375 16.125L3.91859 12.1117C4.02905 11.8245 4.08428 11.6809 4.17901 11.6152C4.26179 11.5577 4.36423 11.5359 4.46322 11.5548C4.5765 11.5765 4.68529 11.6853 4.90286 11.9028L6.59718 13.5972C6.81475 13.8147 6.92354 13.9235 6.94517 14.0368C6.96408 14.1358 6.94234 14.2382 6.88486 14.321C6.81908 14.4157 6.67549 14.471 6.3883 14.5814L2.375 16.125Z"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  schedule_menu_icon: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.25 7.5H2.75M12.5 1.5V4.5M6.5 1.5V4.5M6.35 16.5H12.65C13.9101 16.5 14.5402 16.5 15.0215 16.2548C15.4448 16.039 15.789 15.6948 16.0048 15.2715C16.25 14.7902 16.25 14.1601 16.25 12.9V6.6C16.25 5.33988 16.25 4.70982 16.0048 4.22852C15.789 3.80516 15.4448 3.46095 15.0215 3.24524C14.5402 3 13.9101 3 12.65 3H6.35C5.08988 3 4.45982 3 3.97852 3.24524C3.55516 3.46095 3.21095 3.80516 2.99524 4.22852C2.75 4.70982 2.75 5.33988 2.75 6.6V12.9C2.75 14.1601 2.75 14.7902 2.99524 15.2715C3.21095 15.6948 3.55516 16.039 3.97852 16.2548C4.45982 16.5 5.08988 16.5 6.35 16.5Z"
        stroke="#101828"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  stop_icon: (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" stroke="#6B7280" strokeWidth="1.2" />
      <path d="M4.5 4.5L11.5 11.5" stroke="#6B7280" strokeLinecap="round" strokeWidth="1.2" />
    </svg>
  ),
  suggestion_circle_loaded: (
    <svg viewBox="0 0, 100 100" width="40" className="loader">
      <defs>
        <linearGradient
          id="linear"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
          gradientTransform="rotate(10)"
        >
          <stop offset="10%" className="stop-color" />
          <stop offset="100%" stopColor="whitesmoke" />
        </linearGradient>
      </defs>
      <path
        d="M 50 10 A 40 40 0 1 0 90 50"
        stroke="url(#linear)"
        strokeWidth="13"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  ),
};
export default existingIcons;
